import { observable, decorate, computed, action, reaction, runInAction, toJS, autorun } from 'mobx'

import { IProduct, IVariant, IWorkProduct } from './product.store'
import { ICustomer, IVoucher } from './customer.model'
import { IModifier, modifierStore } from './modifier.store'
import _, {
  remove,
  flatten,
  some,
  find,
  forEach,
  head,
  reduce,
  cloneDeep,
  get,
  map,
  isEqual,
  sumBy,
  findLast,
  includes,
  keys,
  filter,
  orderBy
} from 'lodash'
import { ObjectId, getObjectId } from '../libs/object-id'

import { isBefore, addDays, startOfDay, isAfter, isSameDay } from 'date-fns'
import { RootStore } from './root-store'
import { IOrder } from './list-order.store'
import { getMessageFromErrorResponse, handleAgentErrorResponse } from '../libs/error-handler'
// import {
//   canUseHouseholdInvoice, // Phase 2
//   orderContainsAlcohol // Phase 2
// } from '../libs/tax.utils'
import {
  // TInvoiceSource, // Phase 2
  isTaxableCategory,
  TAX_RATES,
  INVOICE_SOURCE
} from '../libs/tax.config'
import {
  getSelectedVariant,
  getItemSoldPrice,
  getPlatformPrice,
  getOriginalPrice,
  dayStringBetween
} from '../libs/order.util'
import { IOutlet } from './outlet-list.store'
import {
  getSubTOtalWithoutPricedGift,
  getStaffDiscountByBusiness,
  getItemDiscount,
  checkAndGetValidGiftValentine,
  isSetQuaTetItem,
  checkAndGetValidGift8T3,
  checkAndGetValidGiftWomen20t10,
  checkAndGetValidFatherDayGift,
  getMooncakeBundledSalesByType,
  checkAndGetValidMooncakeGiftBox,
  checkCutleryGiftEligibility,
  checkAndGetValidTeacherDayGift,
  checkAndGetValidMotherDay2026Gift,
  checkAndGetValidFatherDay2026Gift,
  processWomen8t3BusinessSetWholesale,
  processChocolateMarch2026Sale
} from '../libs/bulk-discount'
import { processSetQua83Sale, processBuy3Pay2Sale, processFlat99kSale } from '../libs/promotions/set-qua-83-program'
import { processBuy2Pay1Sale } from '../libs/promotions/buy2pay1-program'
import { processTiramisuBirthdayCakeDiscount } from '../libs/promotions/tiramisu-birthday-discount'
import { processMascarponeDiscount } from '../libs/promotions/mascarpone-discount'
import { processComboBacNamMotNha } from '../libs/promotions/combo-bac-nam-mot-nha'
import {
  NEW_CUSTOMER_CAKE_GIFT_SKUS,
  NEW_CUSTOMER_CAKE_GIFT_PROGRAM,
  checkNewCustomerCakeGiftEligibility,
  isInNewCustomerCakeGiftWindow
} from '../libs/promotions/new-customer-cake-gift'
import { toast } from 'react-toastify'
import { partnerDiscounts, IPartnerDiscount } from './partner-discounts.store'
import { getCodeFromShiftRecordId } from './current-shift.store'
import {
  tetCookieSkus,
  mooncake2025Set4Skus,
  mooncake2025Set2Skus,
  mooncake2025SingleSkus,
  mooncake2025Skus
} from '../libs/skus.utils'
import { MOONCAKE_GIFT_SKUS } from '../libs/skus.data'
import { XMAS_PROMOTION_CONFIG } from '../libs/promotions.config'

export interface IItemModifier extends IModifier {
  quantity: number
}

export interface IDiscountItemMap {
  [key: string]: {
    id: string
    discount: number
    saleProgram: string
    noLoyalty?: boolean
  }
}

export type TPaymentType =
  | 'CASH'
  | 'TRANSFER'
  | 'MOMO'
  | 'ZALOPAY'
  | 'AIRPAY'
  | 'GRABPAY'
  | 'VNPAY'
  | 'VINID'
  | 'BAEMIN'
  | 'BE_FOOD'
  | 'GO_JEK'
  | 'LALAMOVE'
  | 'LOSHIP'
  | 'CARD'
  | 'XANH_SM'

export interface IPayment {
  _id?: string
  paymentType: TPaymentType
  code: string
  codes: string[]
  amount: number
  commissionAmount: number
  uniqueId: string
}

export type TOrderType = 'SHIP' | 'SHOP'

export type TCustomerCardStage = 'no customer' | 'not registered' | 'not activated' | 'activated'

// * like erp schema
export interface ICakeVariant {
  type: {
    type: String
    enum: [
      'BASE_BOX',
      'TEXT_IN_BASE',
      'FRUIT',
      'TEXT_IN_CAKE',
      'NOTE',
      'CAKE_FILLING',
      'PANNA_COTTA',
      'CAKE_FILLING_ADDON',
      'CHOUX_CREAM',
      'MOONCAKE_SET',
      'TET_SET',
      'RIBBON_OPTION'
    ]
  }
  description: String
  quantity: { type: Number; default: 1 }
  product: String | IWorkProduct
}

export interface IOrderItem extends IProduct {
  id: string
  quantity: number
  modifiers: IItemModifier[]
  selectedVariant?: IVariant
  noLoyalty: boolean
  hasSaltedEgg?: boolean
  note?: string
  manufacturingDate?: Date
  programReminder?: string
  saleCode?: string
  saleCodeId?: string
  cakeVariants?: ICakeVariant[]
  onlineOrderUid?: String
  onlineOrderId?: String
  cakeOrderSource?: String
  onlineOrderDiscount?: {
    discount: number
    saleProgram?: string
  }
  productTaxPercentage?: number // Store original tax from product when item is added to order
  // taxPercentage inherited from IProduct
}

export interface IComputedItem extends IOrderItem {
  soldPrice: number
  lineTotal: number
  discount?: number
  originalPrice?: number
  saleProgram?: string
  // Additional tax calculation fields
  taxAmount?: number // Calculated tax amount for the item
}

export interface IDiscount {
  description: string
  amount: number
}

export type TShippingProvider =
  | 'Ship ngoài'
  | 'Ship nội bộ'
  | 'Lalamove'
  | 'Giao tại cửa hàng'
  | 'Ahamove'

export type TInvoiceSource = 'company' | 'household' // Still needed by list-order.store.ts

export type TOrderPlatform =
  | 'SAVOR_SHOP'
  | 'NOW'
  | 'LOSHIP'
  | 'GRAB_FOOD'
  | 'GO_FOOD'
  | 'VINID'
  | 'BAEMIN'
  | 'BE_FOOD'
  | 'LALAMOVE'
  | 'XANH_SM'

export type TItemOption = {
  sku: string
  description: string
  countAs: number
  price?: number
}
export type TComboElement = {
  name: string
  selectedItem?: { sku: string }
  itemOptions: TItemOption[]
  maxQuantity: number
}

// FLAG ĐỂ BẬT/TẮT SALE PROGRAMS TỪ API THAY VÌ HARD-CODE
const USE_DYNAMIC_SALE_PROGRAMS = false

export class OrderStore {
  [x: string]: any
  rootStore!: RootStore
  loadRootStore(rootStore: RootStore) {
    runInAction(() => {
      this.rootStore = rootStore
    })
  }
  _id: string = ObjectId()
  orderId: string = ''
  momoTransId: string = ''
  couponCode?: string = ''
  covidCoupon?: string = 'Combo'
  voucherCode?: string = 'NONE'
  couponValidated?: boolean = false
  outlet: IOutlet | string = ''
  items: IOrderItem[] = []
  product?: IProduct | null
  customer: ICustomer | null = null
  computedCustomer: ICustomer | null = null
  voucher: IVoucher | null = null
  userExplicitlySelectedNoVoucher: boolean = false
  // Cashier xác nhận "Khách không nhận quà" — bỏ qua bắt buộc thêm phụ kiện tặng (WT #106468)
  isNewCustomerGiftDeclined: boolean = false
  // Cashier xác nhận "Khách không cho SĐT" — bỏ qua bắt buộc nhập SĐT với đơn bánh sinh
  // nhật HN (chương trình "Ưu đãi khách mới - đặt bánh có quà", WT #106468).
  isCustomerNoPhoneConfirmed: boolean = false
  selectedOrderPlatform: TOrderPlatform = 'SAVOR_SHOP'
  payments?: IPayment[] = []
  // Tax invoice fields - Phase 2
  requestInvoice: boolean = false
  // invoiceSource: TInvoiceSource = 'company'
  shippingProvider?: TShippingProvider | null
  shippingPay: number = 0
  shippingCollect: number = 0
  note: string = ''
  shippingBillNumber?: string = ''
  shippingPaymentMethod?: string = ''
  shippingCustomerName?: string = ''
  shippingCustomerPhone?: string = ''
  shippingCustomerAddress?: string = ''
  onlineOrderId?: string = ''
  selectedServiceMode: string = ''
  status?: 'ordered' | 'done' | null
  ordered?: Date | string
  updated?: Date | string
  autosave: boolean = false
  autoUpdateProductStatus: boolean = true
  openModalPayment: boolean = false
  saving?: boolean = false
  receivedMoney?: number | null = null
  orderPrinting?: any = null
  saleEntryPrinting?: any = null
  activeNowOrders?: any = []
  onlineOrder?: any = null
  deposit: number = 0
  nowOrderCode: string = ''
  linkQrcode: string = ''
  linkQrTransfer: string = ''
  linkQrTransferError: string = ''
  transferContent?: string | null = null
  orderCode?: String | null = null
  goFoodPin?: String | null = null
  transferCode?: String | null = null
  headOrderCode?: String | null = null
  tailOrderCode?: String | null = null
  groupPaid?: boolean
  codes?: string[] = []
  preOrderMooncakeQuantities: {
    batch1: { deo: number; nuong: number; combo: number }
    batch2: { deo: number; nuong: number; combo: number }
    batch3: { deo: number; nuong: number; combo: number }
  } | null = null

  getOutletCode() {
    const currentShiftStore = this.rootStore.currentShiftStore
    const currentOutlet = currentShiftStore.currentOutlet
    const currentShift = currentShiftStore.currentShift
    const currentShifftOutlet = currentShift ? currentShift.outlet : null

    let outlet = currentOutlet || currentShifftOutlet

    let outletCode = _.get(outlet, 'code')
    if (!outletCode && currentShift) {
      outletCode = getCodeFromShiftRecordId(currentShift.shiftRecordId) || ''
    }

    return outletCode
  }

  getOutletRegion() {
    // currentOutlet / currentShift.outlet thường chỉ là ObjectId (chưa populate region),
    // nên resolve outlet đầy đủ từ outletListStore theo code (đáng tin nhờ getOutletCode).
    const outletCode = this.getOutletCode()
    if (!outletCode) {
      return ''
    }
    const outlet = this.rootStore.outletListStore.outlets.find(
      outlet => outlet.code === outletCode
    )
    return _.get(outlet, 'region', '')
  }

  constructor() {
    // Add autorun to track changes in observables
    autorun(() => {
      // console.log('Items:', toJS(this.items))
      // console.log('Computed Customer:', toJS(this.computedCustomer))
      // console.log('Voucher:', toJS(this.voucher))
      // console.log('Available Vouchers:', toJS(this.availableVouchers))
      // console.log('Discounts:', this.discounts)
    })

    // Auto-switch to company invoice when alcohol is detected - Phase 2
    // reaction(
    //   () => this.hasAlcoholItems,
    //   hasAlcohol => {
    //     if (hasAlcohol && this.requestInvoice && this.invoiceSource === 'household') {
    //       runInAction(() => {
    //         this.invoiceSource = 'company'
    //         console.log('Auto-switched to company invoice due to alcohol in order')
    //       })
    //     }
    //   }
    // )
  }

  setCouponCode(couponCode: string) {
    this.couponCode = couponCode
  }

  setCovidCoupon(covidCoupon: string) {
    this.covidCoupon = covidCoupon
  }
  setVoucherCode(voucherCode: string) {
    this.voucherCode = voucherCode
  }

  setCouponCodeValidated() {
    this.couponValidated = true
  }

  get computedReceivableAmount() {
    if (this.payments) {
      return this.payments.reduce((total, payment) => {
        if (!['CASH', 'TRANSFER'].includes(payment.paymentType)) {
          return total + payment.amount
        }
        return total
      }, 0)
    }
    return 0
  }

  get computedServiceMode() {
    if (this.orderPlatform !== 'SAVOR_SHOP' || this.shippingProvider) {
      return 'delivery'
    }
    return this.selectedServiceMode
  }

  get computedReceiveAmount() {
    return this.cashTotal
  }

  get commissionAmount() {
    if (this.orderPlatform === 'LOSHIP') {
      if (!this.couponCode) {
        return this.saleTotal * (20 / 100)
      } else {
        return 0
      }
    }
    if (this.orderPlatform === 'NOW') {
      return this.saleTotal * (15 / 100)
    }
    if (this.orderPlatform === 'XANH_SM') {
      const tax = 4.5
      const endPromo = new Date('2024-10-26T00:00:00+07:00')

      let commissionRate = 20
      if (isBefore(new Date(), endPromo)) {
        commissionRate = 18
      }

      return this.saleTotal * ((commissionRate + tax) / 100)
    }
    if (this.orderPlatform === 'LALAMOVE') {
      const totalWithoutDiscount = reduce(
        this.items,
        (result, item) => {
          if (getItemDiscount(item, this.discountItemMap) > 0) {
            return result
          }
          return result + item.normalPrice * item.quantity
        },
        0
      )
      return totalWithoutDiscount * (15 / 100)
    }

    return 0
  }

  get commissionableAmount() {
    if (this.orderPlatform === 'GRAB_FOOD') {
      return (this.saleTotal * 15) / 100
    }
    if (this.orderPlatform === 'GO_FOOD') {
      return this.saleTotal * (15 / 100)
    }
    if (this.orderPlatform === 'BE_FOOD') {
      return this.saleTotal * (15 / 100)
    }
    if (this.orderPlatform === 'BAEMIN') {
      return this.saleTotal * (17 / 100)
    }
    return 0
  }

  get commissionPercentage() {
    return (this.commissionAmount + this.commissionableAmount) / this.saleTotal
  }

  get orderType(): TOrderType {
    if (this.shippingProvider) {
      return 'SHIP'
    }
    return 'SHOP'
  }

  getPercentDiscount() {
    return 20
  }

  getFlavourMilkTeaSkus() {
    return ['V0710', 'V1804', 'V1805', 'V0708', 'V1807', 'V1809']
  }
  // getBuy1Get1Program(item: IOrderItem) {
  //   const soldPrice = getItemSoldPrice(item, this.orderPlatform, this.orderType)
  //   const flavorMilkTeaSkus = this.getFlavourMilkTeaSkus()

  //   if (item.sku === 'V2331') {
  //     return {
  //       reminder: 'Được tặng topping nha đam cùng số lượng',
  //       saleProgram: 'Mua 1 trà ô long chanh leo tặng 1 topping nha đam',
  //       modifier: 'V0759'
  //     }
  //   }
  //   if (flavorMilkTeaSkus.includes(item.sku)) {
  //     return {
  //       reminder: 'Được tặng topping trân châu trắng cùng số lượng',
  //       saleProgram: 'Mua 1 trà sữa vị tặng 1 topping trân châu trắng',
  //       modifier: 'V0657'
  //     }
  //   }
  //   if (item.category === 'sticky-rice' && soldPrice >= 35000) {
  //     return {
  //       reminder: 'Được tặng topping chả cùng số lượng',
  //       saleProgram: 'Mua 1 xôi bất kì trên 35k tặng 1 topping chả',
  //       modifier: 'V0358'
  //     }
  //   }
  //   return null
  // }

  getDiscountPercentForCakeOrder(total: number, isStaff?: boolean) {
    if (isStaff && total < 20000000) {
      return { discountWithBox: 0.3, discountWithoutBox: 0.35 }
    }
    if (total >= 20000000) {
      return { discountWithBox: 0.4, discountWithoutBox: 0.45 }
    }
    if (total >= 6000000) {
      return { discountWithBox: 0.3, discountWithoutBox: 0.35 }
    }
    if (total >= 2000000) {
      return { discountWithBox: 0.25, discountWithoutBox: 0.3 }
    }
    if (total >= 1000000) {
      return { discountWithBox: 0.2, discountWithoutBox: 0.25 }
    }
    return { discountWithBox: 0, discountWithoutBox: 0.2 }
  }

  get discountItemMap(): IDiscountItemMap {
    const resultMap: IDiscountItemMap = this.items.reduce((result: IDiscountItemMap, item) => {
      result[item.id] = {
        id: item.id,
        discount: 0,
        saleProgram: ''
      }
      return result
    }, {})

    const deliverDeadline =
      this.onlineOrder && this.onlineOrder.deadline
        ? new Date(this.onlineOrder.deadline)
        : new Date()

    // todo: move skus data above to skus.utils.ts or skus.data.ts

    // let date
    // if (this.rootStore.currentShiftStore!.currentShift) {
    //   date = this.rootStore.currentShiftStore!.currentShift!.date
    // }

    // _.forEach(this.items, item => {
    //   const program = this.getBuy1Get1Program(item)

    //   if (!program) {
    //     return
    //   }

    //   _.forEach(item.modifiers, modifier => {
    //     if (modifier.sku !== get(program, 'modifier')) {
    //       return
    //     }
    //     const discountQuantity = item.quantity
    //     const modifierPrice = getModifierPrice(modifier, this.orderPlatform) || 0
    //     resultMap[item.id].discount = modifierPrice * discountQuantity
    //     resultMap[item.id].saleProgram = get(program, 'saleProgram')
    //   })
    // })

    // if (
    //   some(this.items, item => item.sku === 'V10729') &&
    //   ['E9', 'S6', 'B4', 'B5'].includes(this.getOutletCode()) &&
    //   isBefore(deliverDeadline, new Date('2026-03-10T00:00:00+07:00'))
    // ) {
    //   this.items.forEach(item => {
    //     if (item.sku !== 'V10729') {
    //       return
    //     }
    //     const soldPrice = getItemSoldPrice({
    //       item,
    //       orderPlatform: this.orderPlatform,
    //       orderType: this.orderType
    //     })
    //     // Giảm còn 180k
    //     resultMap[item.id].discount = Math.max(soldPrice - 180000, 0) * item.quantity
    //     resultMap[item.id].saleProgram = `Sale 8326: Giảm giá set 4 mousse mua trực tiếp`
    //     resultMap[item.id].noLoyalty = true
    //   })
    // }
    // Giảm giá bánh kẹo Tết

    if (
      some(this.items, item => isSetQuaTetItem(item)) &&
      isBefore(deliverDeadline, new Date('2026-03-31T00:00:00+07:00'))
    ) {
      const totalValue = _.sumBy(this.items, item => {
        if (!isSetQuaTetItem(item)) {
          return 0
        }
        const soldPrice = getItemSoldPrice({
          item,
          orderPlatform: this.orderPlatform,
          orderType: this.orderType
        })
        return soldPrice * item.quantity
      })

      // const activeNewSale =
      //   isAfter(deliverDeadline, new Date('2025-01-25T15:00:00+07:00')) &&
      //   isBefore(deliverDeadline, new Date('2025-02-01T00:00:00+07:00'))
      // const newSaleMap: { [key: number]: number } = {
      //   1: 35
      // }
      if (totalValue >= 0) {
        let saleMap: { [key: number]: number } = {
          5: 10, // 5tr
          20: 15, // 20 tr
          50: 20,
          100: 25,
          200: 30,
          300: 35,
          400: 40
        }
        // if (activeNewSale) {
        //   saleMap = newSaleMap
        // }
        const validValues = filter(keys(saleMap), value => totalValue / 1000000 >= parseInt(value))

        const sortedValidValues = orderBy(validValues, [value => parseInt(value)], ['desc'])

        const discountPercent = sortedValidValues[0] ? saleMap[parseInt(sortedValidValues[0])] : 0

        if (discountPercent) {
          this.items.forEach(item => {
            if (!isSetQuaTetItem(item)) {
              return
            }
            const soldPrice = getItemSoldPrice({
              item,
              orderPlatform: this.orderPlatform,
              orderType: this.orderType
            })
            resultMap[item.id].discount = (item.quantity * soldPrice * discountPercent) / 100
            resultMap[item.id].saleProgram = `Giảm giá sỉ bánh kẹo Tết ${discountPercent}%`
            resultMap[item.id].noLoyalty = true
          })
        }
      }
    }

    // 19/11
    const BUSINESS_SET_MEN_DAY_CONFIG = {
      skus: ['V10450', 'V10451'],
      startDate: new Date('2025-11-12T00:00:00+07:00'),
      endDate: new Date('2025-11-20T00:00:00+07:00'), // hết 19/11
      discountMap: {
        5: 10,
        11: 20,
        51: 25,
        101: 30,
        201: 35
      }
    }
    if (
      some(this.items, item => includes(BUSINESS_SET_MEN_DAY_CONFIG.skus, item.sku)) &&
      isAfter(new Date(), BUSINESS_SET_MEN_DAY_CONFIG.startDate) &&
      isBefore(new Date(), BUSINESS_SET_MEN_DAY_CONFIG.endDate)
    ) {
      const quantityMapToDiscountPercent: { [quantity: string]: number } =
        BUSINESS_SET_MEN_DAY_CONFIG.discountMap
      const businessSetSkus = BUSINESS_SET_MEN_DAY_CONFIG.skus

      const totalBusinessSetQuantity = sumBy(this.items, item => {
        if (!businessSetSkus.includes(item.sku)) {
          return 0
        }
        return item.quantity
      })

      if (totalBusinessSetQuantity > 0) {
        // process discount
        this.items.forEach(item => {
          // Không phải mã được giảm
          if (!businessSetSkus.includes(item.sku)) {
            return
          }

          const quantityKeys = keys(quantityMapToDiscountPercent).sort(
            (a, b) => Number(b) - Number(a)
          )
          const matchQuantityKey = find(quantityKeys, quantityKey => {
            return totalBusinessSetQuantity >= Number(quantityKey)
          })

          if (!matchQuantityKey) {
            // eslint-disable-next-line no-console
            console.log('[processWomen20t10BusinessSetOld] Số lượng không đủ điều kiện giảm giá', {
              sku: item.sku,
              quantity: item.quantity,
              requiredQuantities: keys(quantityMapToDiscountPercent)
            })
            return
          }

          const discountPercent = quantityMapToDiscountPercent[Number(matchQuantityKey)] || 0
          if (discountPercent <= 0) {
            // eslint-disable-next-line no-console
            console.log('[processWomen20t10BusinessSetOld] Giá giảm không hợp lệ', {
              sku: item.sku,
              discountPercent
            })
            return item
          }

          const soldPrice = getItemSoldPrice({
            item,
            orderPlatform: this.orderPlatform,
            orderType: this.orderType
          })
          const lineTotal = soldPrice * item.quantity
          const discount = Math.min(Math.max((lineTotal * discountPercent) / 100, 0), lineTotal)
          const saleProgram = `Giảm giá Set DN 19/11 (${discountPercent}% khi mua tổng từ ${matchQuantityKey} set)`

          resultMap[item.id].discount = discount
          resultMap[item.id].saleProgram = saleProgram
          resultMap[item.id].noLoyalty = true
        })
      }
    }

    // sale after 20/10
    const fruitMousseCupSkuMapToSalePrice: Record<string, number> = {
      V8321: 150000, // 9
      V8323: 190000, // 12
      V8327: 290000, // 25
      V10304: 450000, // 36
      V10305: 550000 // 49
    }
    const saleFruitMousseCupSkus = _.keys(fruitMousseCupSkuMapToSalePrice)
    if (_.some(this.items, item => saleFruitMousseCupSkus.includes(item.sku))) {
      this.items.forEach(item => {
        if (!saleFruitMousseCupSkus.includes(item.sku)) {
          return
        }
        if (item.saleCode) {
          return
        }
        const soldPrice = getItemSoldPrice({
          item,
          orderPlatform: this.orderPlatform,
          orderType: this.orderType
        })
        const salePrice = fruitMousseCupSkuMapToSalePrice[item.sku]
        resultMap[item.id].discount = Math.max(soldPrice - salePrice, 0) * item.quantity
        resultMap[item.id].saleProgram = 'Giảm giá mousse cốc hoa quả'
        resultMap[item.id].noLoyalty = true
      })
    }
    const newSunsetMousseCupSkuMapToSalePrice: Record<string, number> = {
      V10410: 150000, // 9
      V10412: 190000, // 12
      V10414: 290000, // 25
      V10416: 450000, // 36
      V10418: 550000 // 49
    }
    const saleNewSunsetMousseCupSkus = _.keys(newSunsetMousseCupSkuMapToSalePrice)
    const inSaleNewSunsetMousseCupTime = isBefore(new Date(), new Date('2025-11-09T00:00:00+07:00'))
    if (
      inSaleNewSunsetMousseCupTime &&
      _.some(this.items, item => saleNewSunsetMousseCupSkus.includes(item.sku))
    ) {
      this.items.forEach(item => {
        if (!saleNewSunsetMousseCupSkus.includes(item.sku)) {
          return
        }
        if (item.saleCode) {
          return
        }
        const soldPrice = getItemSoldPrice({
          item,
          orderPlatform: this.orderPlatform,
          orderType: this.orderType
        })
        const salePrice = newSunsetMousseCupSkuMapToSalePrice[item.sku]
        resultMap[item.id].discount = Math.max(soldPrice - salePrice, 0) * item.quantity
        resultMap[item.id].saleProgram = 'Giảm giá dùng thử Set bánh cốc mới'
        resultMap[item.id].noLoyalty = true
      })
    }

    // 20/11 teacher day
    if (checkAndGetValidTeacherDayGift(this.items, this.onlineOrder).isValid) {
      const teacherDayGiftConfig = checkAndGetValidTeacherDayGift(this.items, this.onlineOrder)
      const autoGiftSku = teacherDayGiftConfig.giftSku
      let byQtyDiscountAvailNum = teacherDayGiftConfig.giftQuantity

      this.items.forEach(item => {
        // không có mã tặng
        // if (![...pickyGiftSkus, autoGiftSku].includes(item.sku)) {
        //   return
        // }

        let soldPrice = getItemSoldPrice({
          item,
          orderPlatform: this.orderPlatform,
          orderType: this.orderType
        })

        // if (pickyGiftSkus.includes(item.sku)) {
        //   if (!byValueDiscountAvailNum) {
        //     return
        //   }
        //   const discountQuantity = Math.min(byValueDiscountAvailNum, item.quantity)
        //   resultMap[item.id].discount = soldPrice * discountQuantity
        //   resultMap[item.id].saleProgram = 'Tặng que cắm giấy Teacher Day'
        //   resultMap[item.id].noLoyalty = true
        //   byValueDiscountAvailNum -= discountQuantity
        // }

        // Xét mã tặng theo số lượng
        if (item.sku !== autoGiftSku) {
          return
        }
        // đơn ko có bánh 20/11 hoặc giảm max rồi
        if (!byQtyDiscountAvailNum) {
          return
        }
        const discountQuantity = Math.min(byQtyDiscountAvailNum, item.quantity)
        resultMap[item.id].discount = soldPrice * discountQuantity
        resultMap[item.id].saleProgram = teacherDayGiftConfig.saleProgram
        resultMap[item.id].noLoyalty = true
        byQtyDiscountAvailNum -= discountQuantity
      })
    }

    // xmas
    if (
      isAfter(deliverDeadline, get(XMAS_PROMOTION_CONFIG, 'timeframe.start')) &&
      isBefore(deliverDeadline, get(XMAS_PROMOTION_CONFIG, 'timeframe.end'))
    ) {
      const valueGiftSkus = get(XMAS_PROMOTION_CONFIG, 'giftSkusMap.value')
      const quantityGiftSkus = get(XMAS_PROMOTION_CONFIG, 'giftSkusMap.quantity')

      const totalValue = this.items.reduce((result, item) => {
        if ([...valueGiftSkus, ...quantityGiftSkus].includes(item.sku)) {
          return result
        }
        return (
          item.quantity *
            getItemSoldPrice({
              item,
              orderPlatform: this.orderPlatform,
              orderType: this.orderType
            }) +
          result
        )
      }, 0)
      const outletCode = this.getOutletCode()

      const validValueGift =
        totalValue >= 300000 &&
        (!this.onlineOrder ||
          get(this.onlineOrder, 'shipping.provider', '') === 'Giao tại cửa hàng') &&
        !['E9', 'S6'].includes(outletCode)

      let byValueDiscountAvailNum = validValueGift ? 1 : 0
      let byQtyDiscountAvailNum = _.sumBy(this.items, item => {
        if (XMAS_PROMOTION_CONFIG.menuSkus.includes(item.sku)) {
          return item.quantity
        }
        return 0
      })

      this.items.forEach(item => {
        // không có mã tặng
        if (![...valueGiftSkus, ...quantityGiftSkus].includes(item.sku)) {
          return
        }

        let soldPrice = getItemSoldPrice({
          item,
          orderPlatform: this.orderPlatform,
          orderType: this.orderType
        })

        if (valueGiftSkus.includes(item.sku)) {
          if (!byValueDiscountAvailNum) {
            return
          }
          const discountQuantity = Math.min(byValueDiscountAvailNum, item.quantity)
          resultMap[item.id].discount = soldPrice * discountQuantity
          resultMap[item.id].saleProgram = 'Tặng thiệp Giáng sinh'
          resultMap[item.id].noLoyalty = true
          byValueDiscountAvailNum -= discountQuantity
        }

        // Xét mã tặng theo số lượng
        // - mã đang loop qua ko phải mã tặng
        if (!quantityGiftSkus.includes(item.sku)) {
          return
        }
        // - đơn ko có bánh giáng sinh hoặc giảm max rồi
        if (!byQtyDiscountAvailNum) {
          return
        }
        const discountQuantity = Math.min(byQtyDiscountAvailNum, item.quantity)
        resultMap[item.id].discount = soldPrice * discountQuantity
        resultMap[item.id].saleProgram = 'Tặng que cắm Giáng sinh'
        resultMap[item.id].noLoyalty = true
        byQtyDiscountAvailNum -= discountQuantity
      })
    } // End xmas

    // Valentine prepare
    if (checkAndGetValidGiftValentine(this.items, this.onlineOrder, 'mica').isValid) {
      const giftData = checkAndGetValidGiftValentine(this.items, this.onlineOrder, 'mica')

      const quantityGiftSku = giftData.giftSku
      let byQtyDiscountAvailNum = giftData.giftNum

      this.items.forEach(item => {
        // không có mã tặng
        if (![quantityGiftSku].includes(item.sku)) {
          return
        }

        let soldPrice = getItemSoldPrice({
          item,
          orderPlatform: this.orderPlatform,
          orderType: this.orderType
        })

        // Xét mã tặng theo số lượng
        // - mã đang loop qua ko phải mã tặng
        if (item.sku !== quantityGiftSku) {
          return
        }
        // - đơn ko có bánh áp dụng hoặc đã trừ giảm hết rồi
        if (!byQtyDiscountAvailNum) {
          return
        }
        const discountQuantity = Math.min(byQtyDiscountAvailNum, item.quantity)
        resultMap[item.id].discount = soldPrice * discountQuantity
        resultMap[item.id].saleProgram = giftData.saleProgram
        resultMap[item.id].noLoyalty = true
        byQtyDiscountAvailNum -= discountQuantity
      })
    }
    // Valentine thiệp
    if (checkAndGetValidGiftValentine(this.items, this.onlineOrder, 'card').isValid) {
      const giftData = checkAndGetValidGiftValentine(this.items, this.onlineOrder, 'card')

      const quantityGiftSku = giftData.giftSku
      let byQtyDiscountAvailNum = giftData.giftNum

      this.items.forEach(item => {
        let soldPrice = getItemSoldPrice({
          item,
          orderPlatform: this.orderPlatform,
          orderType: this.orderType
        })

        // Xét mã tặng theo số lượng
        // - mã đang loop qua ko phải mã tặng
        if (item.sku !== quantityGiftSku) {
          return
        }
        // - đơn ko có bánh áp dụng hoặc đã trừ giảm hết rồi
        if (!byQtyDiscountAvailNum) {
          return
        }
        const discountQuantity = Math.min(byQtyDiscountAvailNum, item.quantity)
        resultMap[item.id].discount = soldPrice * discountQuantity
        resultMap[item.id].saleProgram = giftData.saleProgram
        resultMap[item.id].noLoyalty = true
        byQtyDiscountAvailNum -= discountQuantity
      })
    }

    // Bánh kẹo tết đầu mùa combo 2 lọ cookie
    if (
      isBefore(new Date(deliverDeadline), new Date('2024-12-27T00:00:00+07:00')) &&
      _.some(this.items, item => tetCookieSkus.includes(item.sku))
    ) {
      // Sort các mã cookie để ưu tiên giảm giá phần combo cho mã có giá bán cao hơn => lợi hơn cho khách
      const sortedItems = _.orderBy(
        this.items,
        [
          // First criteria: is it a Tet cookie (true comes first)
          item => tetCookieSkus.includes(item.sku),
          // Second criteria: price (only matters for Tet cookies)
          item =>
            tetCookieSkus.includes(item.sku)
              ? getItemSoldPrice({
                  item,
                  orderPlatform: this.orderPlatform,
                  orderType: this.orderType
                })
              : 0
        ],
        ['desc', 'desc']
      )

      // Duyệt từng mã cookie để tính giảm giá
      const COMBO_COOKIE_SALE_PRICE_EACH = 99000 / 2
      const cookieCount = _.sumBy(this.items, item => {
        if (tetCookieSkus.includes(item.sku)) {
          return item.quantity
        }
        return 0
      })
      let totalDiscountQuantity = Math.floor(cookieCount / 2) * 2
      sortedItems.forEach(item => {
        if (!tetCookieSkus.includes(item.sku)) {
          return
        }
        if (totalDiscountQuantity <= 0) {
          return
        }
        const discountQuantity = Math.min(item.quantity, totalDiscountQuantity)
        const soldPrice = getItemSoldPrice({
          item,
          orderPlatform: this.orderPlatform,
          orderType: this.orderType
        })
        resultMap[item.id].discount = (soldPrice - COMBO_COOKIE_SALE_PRICE_EACH) * discountQuantity
        resultMap[item.id].saleProgram = 'Combo 2 lọ cookies'
        totalDiscountQuantity -= discountQuantity
        return item
      })
    }

    const nougatSkus = ['V9323', 'V9335']
    if (
      isAfter(deliverDeadline, new Date('2024-12-13T00:00:00+07:00')) &&
      isBefore(deliverDeadline, new Date('2024-12-26T00:00:00+07:00')) &&
      _.some(this.items, item => nougatSkus.includes(item.sku))
    ) {
      this.items.forEach(item => {
        if (!nougatSkus.includes(item.sku)) {
          return
        }
        const soldPrice = getItemSoldPrice({
          item,
          orderPlatform: this.orderPlatform,
          orderType: this.orderType
        })
        resultMap[item.id].discount = ((soldPrice * 20) / 100) * item.quantity
        resultMap[item.id].saleProgram = 'Giảm giá trải nghiệm nougat đầu mùa'
        resultMap[item.id].noLoyalty = true
      })
    }

    if (
      some(this.items, { category: 'birthday-cake' }) &&
      isAfter(new Date(), new Date('2025-11-08T00:00:00+07:00'))
    ) {
      let totalDiscount = 1
      this.items.forEach(item => {
        if (!MOONCAKE_GIFT_SKUS.includes(item.sku) || totalDiscount < 1) {
          return
        }

        let soldPrice = getItemSoldPrice({
          item,
          orderPlatform: this.orderPlatform,
          orderType: this.orderType
        })

        const numDiscount = Math.min(totalDiscount, item.quantity)

        resultMap[item.id].discount = soldPrice * numDiscount
        resultMap[item.id].saleProgram = 'Tặng bánh trung thu'
        resultMap[item.id].noLoyalty = true

        totalDiscount -= numDiscount
      })
    }

    // Giảm giá bánh trung thu
    // if (
    //   isAfter(deliverDeadline, new Date('2025-08-01T00:00:00+07:00')) &&
    //   isBefore(deliverDeadline, new Date('2025-11-30T00:00:00+07:00')) &&
    //   _.some(this.items, item => mooncakeRetailSkus.includes(item.sku))
    // ) {
    //   // Đếm tổng số bánh trung thu lẻ trong đơn
    //   const totalMooncakeRetailQty = _.sumBy(this.items, item => {
    //     if (mooncakeRetailSkus.includes(item.sku)) {
    //       return item.quantity
    //     }
    //     return 0
    //   })

    //   // Tính số lượng được tặng: mua 1 tặng 2 = mỗi 3 bánh thì 2 bánh được miễn phí
    //   // Ví dụ: mua 3 bánh -> tặng 2, mua 6 bánh -> tặng 4, mua 9 bánh -> tặng 6
    //   const giftQuantity = Math.floor(totalMooncakeRetailQty / 3) * 2

    //   if (giftQuantity > 0) {
    //     // Sắp xếp các bánh theo giá từ thấp đến cao để ưu tiên giảm giá cho bánh rẻ trước
    //     const sortedItems = _.orderBy(
    //       this.items.filter(item => mooncakeRetailSkus.includes(item.sku)),
    //       [
    //         item =>
    //           getItemSoldPrice({
    //             item,
    //             orderPlatform: this.orderPlatform,
    //             orderType: this.orderType
    //           })
    //       ],
    //       ['asc']
    //     )

    //     let remainingGiftQty = giftQuantity

    //     sortedItems.forEach(item => {
    //       if (remainingGiftQty <= 0) {
    //         return
    //       }

    //       const soldPrice = getItemSoldPrice({
    //         item,
    //         orderPlatform: this.orderPlatform,
    //         orderType: this.orderType
    //       })

    //       // Số lượng được giảm giá cho item này
    //       const discountQty = Math.min(item.quantity, remainingGiftQty)

    //       resultMap[item.id].discount = soldPrice * discountQty
    //       resultMap[item.id].saleProgram = 'Mua 1 tặng 2 - Bánh trung thu lẻ'
    //       resultMap[item.id].noLoyalty = true

    //       remainingGiftQty -= discountQty
    //     })
    //   }
    // }

    // 8/3
    if (checkAndGetValidGift8T3(this.items, this.onlineOrder, 'card').isValid) {
      const giftData = checkAndGetValidGift8T3(this.items, this.onlineOrder, 'card')
      const quantityGiftSku = giftData.giftSku
      let giftNum = giftData.giftNum

      this.items.forEach(item => {
        if (item.sku !== quantityGiftSku) {
          return
        }
        if (!giftNum) {
          return
        }
        const soldPrice = getItemSoldPrice({
          item,
          orderPlatform: this.orderPlatform,
          orderType: this.orderType
        })
        const discountQuantity = Math.min(giftNum, item.quantity)
        resultMap[item.id].discount = soldPrice * discountQuantity
        resultMap[item.id].saleProgram = giftData.saleProgram
        resultMap[item.id].noLoyalty = true
        giftNum -= discountQuantity
      })
    }
    if (checkAndGetValidGift8T3(this.items, this.onlineOrder, 'sparkle').isValid) {
      const giftData = checkAndGetValidGift8T3(this.items, this.onlineOrder, 'sparkle')
      const quantityGiftSku = giftData.giftSku
      let giftNum = giftData.giftNum

      this.items.forEach(item => {
        if (item.sku !== quantityGiftSku) {
          return
        }
        if (!giftNum) {
          return
        }
        const soldPrice = getItemSoldPrice({
          item,
          orderPlatform: this.orderPlatform,
          orderType: this.orderType
        })
        const discountQuantity = Math.min(giftNum, item.quantity)
        resultMap[item.id].discount = soldPrice * discountQuantity
        resultMap[item.id].saleProgram = giftData.saleProgram
        resultMap[item.id].noLoyalty = true
        giftNum -= discountQuantity
      })
    }

    // 20/10
    if (checkAndGetValidGiftWomen20t10(this.items, this.onlineOrder, 'card').isValid) {
      const giftData = checkAndGetValidGiftWomen20t10(this.items, this.onlineOrder, 'card')
      const quantityGiftSku = giftData.giftSku
      let giftNum = giftData.giftNum

      this.items.forEach(item => {
        if (item.sku !== quantityGiftSku) {
          return
        }
        if (!giftNum) {
          return
        }
        const soldPrice = getItemSoldPrice({
          item,
          orderPlatform: this.orderPlatform,
          orderType: this.orderType
        })
        const discountQuantity = Math.min(giftNum, item.quantity)
        resultMap[item.id].discount = soldPrice * discountQuantity
        resultMap[item.id].saleProgram = giftData.saleProgram
        resultMap[item.id].noLoyalty = true
        giftNum -= discountQuantity
      })
    }
    if (checkAndGetValidGiftWomen20t10(this.items, this.onlineOrder, 'sparkle').isValid) {
      const giftData = checkAndGetValidGiftWomen20t10(this.items, this.onlineOrder, 'sparkle')
      const quantityGiftSku = giftData.giftSku
      let giftNum = giftData.giftNum

      this.items.forEach(item => {
        if (item.sku !== quantityGiftSku) {
          return
        }
        if (!giftNum) {
          return
        }
        const soldPrice = getItemSoldPrice({
          item,
          orderPlatform: this.orderPlatform,
          orderType: this.orderType
        })
        const discountQuantity = Math.min(giftNum, item.quantity)
        resultMap[item.id].discount = soldPrice * discountQuantity
        resultMap[item.id].saleProgram = giftData.saleProgram
        resultMap[item.id].noLoyalty = true
        giftNum -= discountQuantity
      })
    }

    // Chương trình tặng Bộ dao dĩa cao cấp
    const cutleryGift = checkCutleryGiftEligibility({
      customer: this.computedCustomer,
      orderPlatform: this.orderPlatform,
      items: this.items,
      orderType: this.orderType
    })
    if (cutleryGift.isEligible) {
      let giftQuantity = cutleryGift.maxQuantity

      this.items.forEach(item => {
        if (item.sku !== cutleryGift.giftSku) {
          return
        }
        if (!giftQuantity) {
          return
        }
        const soldPrice = getItemSoldPrice({
          item,
          orderPlatform: this.orderPlatform,
          orderType: this.orderType
        })
        const discountQuantity = Math.min(giftQuantity, item.quantity)
        resultMap[item.id].discount = soldPrice * discountQuantity
        resultMap[item.id].saleProgram = 'Tặng Bộ dao dĩa cao cấp - Khách hàng thân thiết'
        resultMap[item.id].noLoyalty = true
        giftQuantity -= discountQuantity
      })
    }

    // Quà "Ưu đãi khách mới - đặt bánh có quà" (WT #106468) — Savor Cake HN, từ 22/6.
    // Tặng free 1 phụ kiện whitelist có soldPrice cao nhất trong đơn (lợi cho khách).
    const newCustomerCakeGift = checkNewCustomerCakeGiftEligibility({
      customer: this.computedCustomer,
      items: this.items,
      region: this.getOutletRegion(),
      orderPlatform: this.orderPlatform,
      now: new Date()
    })
    if (newCustomerCakeGift.isEligible && !this.isNewCustomerGiftDeclined) {
      let giftItem: IOrderItem | null = null
      let giftSoldPrice = 0
      this.items.forEach(item => {
        if (!NEW_CUSTOMER_CAKE_GIFT_SKUS.includes(item.sku)) {
          return
        }
        const soldPrice = getItemSoldPrice({
          item,
          orderPlatform: this.orderPlatform,
          orderType: this.orderType
        })
        if (soldPrice > giftSoldPrice) {
          giftSoldPrice = soldPrice
          giftItem = item
        }
      })
      if (giftItem) {
        // Giảm full giá đúng 1 chiếc (tối đa 1 quà/đơn, độc lập số lượng phụ kiện)
        resultMap[giftItem!.id].discount = giftSoldPrice
        resultMap[giftItem!.id].saleProgram = NEW_CUSTOMER_CAKE_GIFT_PROGRAM
        resultMap[giftItem!.id].noLoyalty = true
      }
    }

    // Chiết khấu Set DN 8/3 - chỉ áp dụng cho đơn SHOP (không có onlineOrder)
    if (!this.onlineOrder) {
      processWomen8t3BusinessSetWholesale({
        items: this.items,
        deadline: new Date(),
        resultMap,
        orderPlatform: this.orderPlatform,
        orderType: this.orderType
      })
    }

    this.items.forEach(item => {
      const expiryDays = item.shelfLife ? item.shelfLife / 2 : 0
      if (item.saleCode) {
        return
      }
      if (item.sku === 'V1408') {
        const soldPrice = getItemSoldPrice({
          item,
          orderPlatform: this.orderPlatform,
          orderType: this.orderType
        })
        const discount = soldPrice - Math.floor((soldPrice * 75) / 100 / 10000) * 10000

        resultMap[item.id].discount = discount
        resultMap[item.id].saleProgram = 'Giảm giá combo bánh ngọt'
        resultMap[item.id].noLoyalty = true
      }
    })

    // Tặng kẹo singum
    let numDiscountSinggum = 1
    this.items.forEach(item => {
      if (item.sku !== 'V8777' || !numDiscountSinggum) {
        return
      }
      const soldPrice = getItemSoldPrice({
        item,
        orderPlatform: this.orderPlatform,
        orderType: this.orderType
      })
      const discountQuantity = Math.min(item.quantity, 1)
      resultMap[item.id].discount = soldPrice * discountQuantity
      resultMap[item.id].saleProgram = 'Chương trình tặng Kẹo sing-gum doublemint sample'
      numDiscountSinggum -= discountQuantity
    })
    // START SAVOR_SHOP SALE
    if (this.orderPlatform === 'SAVOR_SHOP') {
      // mother day
      const outletCode = this.getOutletCode()
      if (checkAndGetValidFatherDayGift(this.items, this.onlineOrder, outletCode).isValid) {
        const giftData = checkAndGetValidFatherDayGift(this.items, this.onlineOrder, outletCode)
        let totalGiftQty = giftData.giftNum

        this.items.forEach(item => {
          if (item.sku !== giftData.giftSku) {
            return
          }
          if (!totalGiftQty) {
            return
          }
          const soldPrice = getItemSoldPrice({
            item,
            orderPlatform: this.orderPlatform,
            orderType: this.orderType
          })
          const discountQuantity = Math.min(totalGiftQty, item.quantity)
          resultMap[item.id].discount = soldPrice * discountQuantity
          resultMap[item.id].saleProgram = giftData.saleProgram
          resultMap[item.id].noLoyalty = true
          totalGiftQty -= discountQuantity
        })
      }

      // Mother Day 2026: tặng V1443 cho mỗi bánh menu Ngày Của Mẹ
      if (checkAndGetValidMotherDay2026Gift(this.items, this.onlineOrder).isValid) {
        const giftData = checkAndGetValidMotherDay2026Gift(this.items, this.onlineOrder)
        let totalGiftQty = giftData.giftNum

        this.items.forEach(item => {
          if (item.sku !== giftData.giftSku) {
            return
          }
          if (!totalGiftQty) {
            return
          }
          const soldPrice = getItemSoldPrice({
            item,
            orderPlatform: this.orderPlatform,
            orderType: this.orderType
          })
          const discountQuantity = Math.min(totalGiftQty, item.quantity)
          resultMap[item.id].discount = soldPrice * discountQuantity
          resultMap[item.id].saleProgram = giftData.saleProgram
          resultMap[item.id].noLoyalty = true
          totalGiftQty -= discountQuantity
        })
      }

      // Father Day 2026: tặng V8728 cho mỗi bánh menu Ngày Của Cha
      if (checkAndGetValidFatherDay2026Gift(this.items, this.onlineOrder).isValid) {
        const giftData = checkAndGetValidFatherDay2026Gift(this.items, this.onlineOrder)
        let totalGiftQty = giftData.giftNum

        this.items.forEach(item => {
          if (item.sku !== giftData.giftSku) {
            return
          }
          if (!totalGiftQty) {
            return
          }
          const soldPrice = getItemSoldPrice({
            item,
            orderPlatform: this.orderPlatform,
            orderType: this.orderType
          })
          const discountQuantity = Math.min(totalGiftQty, item.quantity)
          resultMap[item.id].discount = soldPrice * discountQuantity
          resultMap[item.id].saleProgram = giftData.saleProgram
          resultMap[item.id].noLoyalty = true
          totalGiftQty -= discountQuantity
        })
      }

      // Tri ân 100k khách
      if (
        isAfter(deliverDeadline, new Date('2025-01-10T00:00:00+07:00')) &&
        isBefore(deliverDeadline, new Date('2025-01-20T00:00:00+07:00'))
      ) {
        const DISCOUNT_RATE = 10
        let totalDiscount = 100000
        this.items.forEach(item => {
          if (item.category !== 'birthday-cake') {
            return
          }
          if (totalDiscount <= 0) {
            return
          }
          const soldPrice = getItemSoldPrice({
            item,
            orderPlatform: this.orderPlatform,
            orderType: this.orderType
          })
          const title = `Giảm 10% tri ân 100k khách hàng`
          const currentDiscountProgram = resultMap[item.id].saleProgram
          if (currentDiscountProgram.includes(title)) {
            return
          }
          const otherDiscount = resultMap[item.id].discount

          const thisDiscount = Math.min(
            (soldPrice * item.quantity - otherDiscount) * (DISCOUNT_RATE / 100),
            totalDiscount
          )
          resultMap[item.id].discount += thisDiscount
          resultMap[item.id].noLoyalty = true
          totalDiscount -= thisDiscount

          if (otherDiscount) {
            resultMap[item.id].saleProgram += `; ${title} ${thisDiscount / 1000}k`
          } else {
            resultMap[item.id].saleProgram = title
          }
        })
      }

      // Giảm giá cho cơ sở hội chợ
      if (
        this.rootStore.currentShiftStore.currentShift &&
        this.rootStore.currentShiftStore.currentShift.shiftRecordId.match(/(HOICHO)/) &&
        isBefore(new Date(), new Date('2025-11-15T23:59:59+07:00'))
      ) {
        // Tính tổng giá trị đơn hàng
        const totalOrderValue = sumBy(
          this.items.map(item => {
            const basePrice = getPlatformPrice(item, this.orderPlatform)
            return basePrice * item.quantity
          })
        )

        // Áp dụng giảm giá 65k nếu đơn hàng >= 299k
        if (totalOrderValue >= 299000) {
          let remainingDiscount = 65000

          // Phân bổ giảm giá cho các item theo tỷ lệ giá trị
          this.items.forEach(item => {
            if (remainingDiscount <= 0) {
              return
            }

            const basePrice = getPlatformPrice(item, this.orderPlatform)
            const itemTotalValue = basePrice * item.quantity
            const itemDiscountAmount = Math.min(
              Math.round((itemTotalValue / totalOrderValue) * 65000),
              remainingDiscount
            )

            if (itemDiscountAmount > 0) {
              resultMap[item.id].discount = itemDiscountAmount
              resultMap[item.id].saleProgram = 'Giảm 65k cho đơn từ 299k'
              resultMap[item.id].noLoyalty = true
              remainingDiscount -= itemDiscountAmount
            }
          })
        }
      }

      // Giảm giá theo chương trình tặng nước cho nhân viên
      if (
        this.customer &&
        get(this.computedCustomer, 'numRemainDiscount', 0) > 0 &&
        get(this.computedCustomer, 'drinkSkus', []).length > 0
      ) {
        let numDiscountItem = get(this.computedCustomer, 'numRemainDiscount', 0)
        let remainDiscountValue = get(this.computedCustomer, 'remainDiscountValue')
        const drinkSkus: string[] = get(this.computedCustomer, 'drinkSkus', [])

        this.items.forEach(item => {
          if (!numDiscountItem || !drinkSkus.length) {
            return
          }
          if (drinkSkus.includes(item.sku) && !item.comboName) {
            const basePrice = getPlatformPrice(item, this.orderPlatform)
            const discountQty = remainDiscountValue ? item.quantity : 1
            const rootDiscount = basePrice * 1 * discountQty
            resultMap[item.id].discount = remainDiscountValue
              ? Math.min(rootDiscount, remainDiscountValue)
              : rootDiscount
            resultMap[item.id].saleProgram = 'Giảm giá theo chương trình tặng nước cho nhân viên'
            resultMap[item.id].noLoyalty = true
            numDiscountItem -= 1
          }
        })
      }

      // Giảm giá bánh kẹo Tết cho nhân viên
      if (this.customer && get(this.computedCustomer, 'tetCakeCandySkus', []).length > 0) {
        const tetCakeCandySkus: string[] = get(this.computedCustomer, 'tetCakeCandySkus', [])
        const tetCakeCandyProducts = get(this.computedCustomer, 'tetCakeCandyProducts', []) as {
          sku: string
          salePrice?: number
        }[]
        const saleMap: { [key: string]: number } = _.reduce(
          tetCakeCandyProducts,
          (result, item) => {
            if (item.salePrice) {
              result[item.sku] = item.salePrice
            }
            return result
          },
          {} as { [key: string]: number } // Add index signature
        )
        const percent = get(this.computedCustomer, 'tetCakeCandyPercent', 0)
        const rootMaxDiscountTotal = get(this.computedCustomer, 'tetCakeCandyMaxDiscountTotal', 0)
        const hasLimitDiscount = rootMaxDiscountTotal > 0
        let maxDiscountTotal = hasLimitDiscount ? rootMaxDiscountTotal : 0
        this.items.forEach(item => {
          if (!tetCakeCandySkus.length) {
            return
          }
          if (hasLimitDiscount && maxDiscountTotal <= 0) {
            return
          }
          if (tetCakeCandySkus.includes(item.sku) && !item.comboName) {
            const basePrice = getPlatformPrice(item, this.orderPlatform)
            let discountValue = basePrice * (percent / 100)
            if (saleMap[item.sku]) {
              discountValue = basePrice - saleMap[item.sku]
            }
            const totalItemDiscount = discountValue * item.quantity
            let finalDiscountValue = totalItemDiscount
            if (hasLimitDiscount) {
              finalDiscountValue = Math.min(totalItemDiscount, maxDiscountTotal)
              maxDiscountTotal -= finalDiscountValue
            }
            resultMap[item.id].discount = finalDiscountValue
            resultMap[item.id].saleProgram = 'Giảm giá bánh kẹo Tết cho nhân viên'
            resultMap[item.id].noLoyalty = true
          }
        })
      }

      // --- Start Mooncake ---
      const hasMooncake = some(this.items, item => mooncake2025Skus.includes(item.sku))
      const validDate = isBefore(
        this.onlineOrder && this.onlineOrder.deadline
          ? new Date(this.onlineOrder.deadline)
          : new Date(),
        new Date('2025-10-20T00:00:00+07:00')
      )

      // Sử dụng Sale Programs từ API
      if (hasMooncake && validDate && USE_DYNAMIC_SALE_PROGRAMS) {
        console.log('Mooncake: use dynamic sale programs')
        // Lấy matched programs giống như ERP
        // const outletId = typeof this.outlet === 'string' ? this.outlet : get(this.outlet, '_id')
        // const matchedPrograms = this.rootStore.saleProgramStore.getMatchedPrograms(
        //   outletId,
        //   this.customer
        // )

        // if (matchedPrograms.length > 0) {
        //   // Tính tổng số lượng bánh trung thu
        //   const mooncakeQuantities = {
        //     normal: 0,
        //     mini: 0
        //   }

        //   // Tìm program phù hợp cho bánh trung thu
        //   let applicableProgram: any = null
        //   for (const program of matchedPrograms) {
        //     // Check xem program có chứa sản phẩm bánh trung thu không
        //     const hasMooncakeProduct = program.products.some((p: any) => {
        //       const sku = p.sku || get(p.product, 'sku')
        //       return mooncake2025Skus.includes(sku)
        //     })
        //     if (hasMooncakeProduct && program.bundlePrices && program.bundlePrices.length > 0) {
        //       applicableProgram = program
        //       break
        //     }
        //   }

        //   if (applicableProgram) {
        //     // Tính tổng số lượng
        //     this.items.forEach(item => {
        //       if (mooncake2025Skus.includes(item.sku)) {
        //         const productInProgram = applicableProgram.products.find((p: any) => {
        //           const sku = p.sku || get(p.product, 'sku')
        //           return sku === item.sku
        //         })

        //         if (productInProgram) {
        //           const isMini = item.sku === 'V9014'
        //           const countAs = productInProgram.countAs || 1

        //           if (isMini) {
        //             mooncakeQuantities.mini += item.quantity
        //           } else {
        //             mooncakeQuantities.normal += item.quantity * countAs
        //           }
        //         }
        //       }
        //     })

        //     // Áp dụng discount cho từng item
        //     this.items.forEach(item => {
        //       if (mooncake2025Skus.includes(item.sku)) {
        //         const productInProgram = applicableProgram.products.find((p: any) => {
        //           const sku = p.sku || get(p.product, 'sku')
        //           return sku === item.sku
        //         })

        //         if (productInProgram) {
        //           const isMini = item.sku === 'V9014'
        //           const totalQty = isMini ? mooncakeQuantities.mini : mooncakeQuantities.normal

        //           // Tìm mốc giảm giá phù hợp
        //           const applicableBundle = applicableProgram.bundlePrices
        //             .filter((bp: any) => totalQty >= bp.quantity)
        //             .sort((a: any, b: any) => b.quantity - a.quantity)[0]

        //           if (applicableBundle && applicableBundle.percent) {
        //             const basePrice = getPlatformPrice(item, this.orderPlatform)

        //             resultMap[item.id].discount =
        //               (basePrice * item.quantity * applicableBundle.percent) / 100
        //             resultMap[item.id].saleProgram =
        //               applicableProgram.title || 'Giá sỉ bánh trung thu'
        //             resultMap[item.id].noLoyalty = true
        //           }
        //         }
        //       }
        //     })

        //     console.log('Applied sale program discounts:', resultMap)
        //   }
        // }
      } else if (hasMooncake && validDate && !USE_DYNAMIC_SALE_PROGRAMS) {
        // Logic cũ (giữ lại để backup)
        // ưu tiên giảm theo NV trước, nếu hết lượt giảm thì xét giảm như khách thường
        console.log('Mooncake: No use dynamic sale programs')
        console.log('Mooncake skus', get(this.computedCustomer, 'mooncakeSkus', []))
        console.log(
          'Mooncake numRemainMooncakeDiscount',
          get(this.computedCustomer, 'numRemainMooncakeDiscount', 0)
        )
        if (
          this.customer &&
          get(this.computedCustomer, 'numRemainMooncakeDiscount', 0) > 0 &&
          get(this.computedCustomer, 'mooncakeSkus', []).length > 0
        ) {
          console.log('Mooncake: set customer discount')

          const mooncakeSkus: string[] = get(this.computedCustomer, 'mooncakeSkus', [])
          const percent = get(this.computedCustomer, 'mooncakePercent', 0)
          let availableDiscount = 500000
          this.items.forEach(item => {
            if (!mooncakeSkus.length || !availableDiscount) {
              return
            }
            if (mooncakeSkus.includes(item.sku) && !item.comboName) {
              const basePrice = getPlatformPrice(item, this.orderPlatform)
              resultMap[item.id].discount =
                Math.min(availableDiscount, basePrice * (percent / 100)) * item.quantity
              resultMap[item.id].saleProgram = 'Giảm giá bánh trung thu cho nhân viên'
              resultMap[item.id].noLoyalty = true
              availableDiscount -= resultMap[item.id].discount
            }
          })
        } else {
          // Tính theo số sản phẩm thay vì số bánh như 2024
          const bundledSalesForSet4 = getMooncakeBundledSalesByType('set4')
          const bundledSalesForSet2 = getMooncakeBundledSalesByType('set2')
          const bundledSalesForSingle = getMooncakeBundledSalesByType('single')
          const countMooncakeMap: { [key: string]: number } = reduce(
            this.items,
            (result, item) => {
              if (!mooncake2025Skus.includes(item.sku)) {
                return result
              }
              if (mooncake2025SingleSkus.includes(item.sku)) {
                return { ...result, single: result.single + item.quantity }
              }
              if (mooncake2025Set2Skus.includes(item.sku)) {
                return { ...result, set2: result.set2 + item.quantity }
              }
              if (mooncake2025Set4Skus.includes(item.sku)) {
                return { ...result, set4: result.set4 + item.quantity }
              }
              return result
            },
            {
              set2: 0,
              set4: 0,
              single: 0
            }
          )

          console.log('countMooncakeMap:', countMooncakeMap)
          this.items.forEach(item => {
            if (!mooncake2025Skus.includes(item.sku)) {
              return
            }
            const soldPrice = getItemSoldPrice({
              item,
              orderPlatform: this.orderPlatform,
              orderType: this.orderType
            })
            const currentType = mooncake2025Set4Skus.includes(item.sku)
              ? 'set4'
              : mooncake2025Set2Skus.includes(item.sku)
                ? 'set2'
                : 'single'
            const bundledSales =
              currentType === 'set4'
                ? bundledSalesForSet4
                : currentType === 'set2'
                  ? bundledSalesForSet2
                  : bundledSalesForSingle
            // giữa 20% discount trial đầu mùa và % sỉ nếu có, lấy cái giảm nhiều hơn cho khách
            let discountRate = 0
            const adhocDiscountRate = 20
            const totalQtyForDiscount = countMooncakeMap[currentType] || 0
            console.log('Mooncake type:', currentType, 'totalQtyForDiscount:', totalQtyForDiscount)
            const matchedBundleSales = _.filter(
              bundledSales,
              bundledSale => totalQtyForDiscount >= bundledSale.quantity
            )
            console.log('matchedBundleSales:', matchedBundleSales)
            const bundleDiscountRate = _.get(_.last(matchedBundleSales), 'discount', 0)
            const adhocDiscount =
              isBefore(deliverDeadline, new Date('2024-09-02T00:00:00+07:00')) &&
              isAfter(deliverDeadline, new Date('2024-08-27T00:00:00+07:00')) &&
              bundleDiscountRate < adhocDiscountRate
            if (adhocDiscount) {
              if (item.sku === 'V9014') {
                return
              }
              discountRate = adhocDiscountRate
            } else if (bundleDiscountRate) {
              discountRate = bundleDiscountRate
            }
            if (!discountRate) {
              return
            }
            resultMap[item.id].discount = (soldPrice * item.quantity * discountRate) / 100
            const typeName =
              currentType === 'set4' ? 'Set 4' : currentType === 'set2' ? 'Set 2' : 'Lẻ'
            resultMap[item.id].saleProgram = adhocDiscount
              ? 'Flashsale bánh trung thu mừng Quốc Khánh'
              : `Giá sỉ bánh trung thu (${typeName} - ${discountRate}%)`
            resultMap[item.id].noLoyalty = true
          })
        }
      }

      // Tặng hộp con cho bánh trung thu lẻ
      const mooncakeGiftBoxData = checkAndGetValidMooncakeGiftBox(this.items)
      if (mooncakeGiftBoxData.isValid) {
        let remainingGiftCount = mooncakeGiftBoxData.giftQuantity

        this.items.forEach(item => {
          // Nếu là mã hộp được tặng và có trong đơn hàng
          if (mooncakeGiftBoxData.giftSkus.includes(item.sku) && remainingGiftCount > 0) {
            // Tặng tối đa bằng số lượng bánh lẻ
            const giftQuantity = Math.min(item.quantity, remainingGiftCount)
            const soldPrice = getItemSoldPrice({
              item,
              orderPlatform: this.orderPlatform,
              orderType: this.orderType
            })

            resultMap[item.id].discount = giftQuantity * soldPrice
            resultMap[item.id].saleProgram = mooncakeGiftBoxData.saleProgram
            resultMap[item.id].noLoyalty = true

            remainingGiftCount -= giftQuantity
          }
        })
      }

      // Chuong tình giam gia ban trung thu khi mua bánh sinh nhật
      // const isMooncakeDiscountWithBirthdayCake =
      //   this.computedCustomer &&
      //   checkMooncakeDiscountWithBirthdayCake({
      //     customer: this.computedCustomer,
      //     items: this.items,
      //     orderPlatform: this.orderPlatform
      //   })
      // // Chỉ xử lý đơn trực tiếp, online order có logic bên ERP rồi
      // if (!this.onlineOrder && isMooncakeDiscountWithBirthdayCake) {
      //   const mooncakeDiscountResult = get(
      //     this.computedCustomer,
      //     'mooncakeDiscountWithBirthdayCakeResult'
      //   )

      //   const MAX_DISCOUNT_PERCENT = 50 // Giảm 50%
      //   let remainingDiscount = mooncakeDiscountResult.remainingDiscountToday || 0

      //   // eslint-disable-next-line no-console
      //   console.log('[Bánh trung thu] Bắt đầu áp dụng giảm giá, còn lại:', remainingDiscount)
      //   if (remainingDiscount > 0) {
      //     const clonedItems: IOrderItem[] = cloneDeep(this.items)

      //     // Lưu lại discount hiện tại của TẤT CẢ items trước khi thử áp dụng BTT-BSN
      //     const originalResultMap: { [key: string]: any } = {}
      //     Object.keys(resultMap).forEach(itemId => {
      //       originalResultMap[itemId] = {
      //         discount: get(resultMap[itemId], 'discount', 0),
      //         saleProgram: get(resultMap[itemId], 'saleProgram', ''),
      //         noLoyalty: get(resultMap[itemId], 'noLoyalty', false)
      //       }
      //     })

      //     // Tính tổng discount của CẢ ĐƠN trước khi áp dụng BTT-BSN
      //     const totalDiscountBeforeBTT = sumBy(Object.values(originalResultMap), 'discount')

      //     // Áp dụng thử discount BTT-BSN cho các item bánh trung thu
      //     clonedItems.forEach(item => {
      //       if (remainingDiscount <= 0) {
      //         return
      //       }
      //       const workName = get(item, 'productCatWorkName')
      //       if (workName !== 'Bánh trung thu') {
      //         return
      //       }

      //       const soldPrice = getItemSoldPrice({
      //         item,
      //         orderPlatform: this.orderPlatform,
      //         orderType: this.orderType
      //       })
      //       const tempItemDiscount = (soldPrice * item.quantity * MAX_DISCOUNT_PERCENT) / 100
      //       const itemDiscount = Math.min(tempItemDiscount, remainingDiscount)

      //       // Áp dụng discount BTT-BSN vào resultMap
      //       resultMap[item.id].discount = itemDiscount
      //       resultMap[item.id].saleProgram = 'Giảm 50% BTT khi mua BSN'
      //       resultMap[item.id].noLoyalty = true
      //       remainingDiscount -= itemDiscount
      //     })

      //     // Tính tổng discount của CẢ ĐƠN sau khi áp dụng BTT-BSN
      //     const totalDiscountAfterBTT = sumBy(
      //       this.items.map(item => get(resultMap[item.id], 'discount', 0))
      //     )

      //     // So sánh tổng discount CẢ ĐƠN và quyết định giữ hay không
      //     if (totalDiscountAfterBTT > totalDiscountBeforeBTT) {
      //       // Giữ discount BTT-BSN mới (đã áp dụng ở trên)
      //       console.log(
      //         '[BTT-BSN] Áp dụng discount BTT-BSN (tổng cả đơn tốt hơn):',
      //         totalDiscountAfterBTT,
      //         '> trước:',
      //         totalDiscountBeforeBTT
      //       )
      //     } else {
      //       // Khôi phục lại discount cũ cho TẤT CẢ items
      //       Object.keys(originalResultMap).forEach(itemId => {
      //         resultMap[itemId] = originalResultMap[itemId]
      //       })
      //       console.log(
      //         '[BTT-BSN] Giữ discount cũ (tổng cả đơn không tốt hơn):',
      //         totalDiscountAfterBTT,
      //         '<= trước:',
      //         totalDiscountBeforeBTT
      //       )
      //     }
      //   }
      // }

      // Chỉ áp dụng mua đơn trực tiếp
      if (
        !this.onlineOrder &&
        getSubTOtalWithoutPricedGift(this.items, this.orderPlatform, this.orderType) >= 250000
      ) {
        const MAX_DISCOUNT_PERCENT = 50 // Giảm 50%
        const clonedItems: IOrderItem[] = cloneDeep(this.items)

        // Lưu lại discount hiện tại của TẤT CẢ items trước khi thử áp dụng BTT-BSN
        const originalResultMap: { [key: string]: any } = {}
        Object.keys(resultMap).forEach(itemId => {
          originalResultMap[itemId] = {
            discount: get(resultMap[itemId], 'discount', 0),
            saleProgram: get(resultMap[itemId], 'saleProgram', ''),
            noLoyalty: get(resultMap[itemId], 'noLoyalty', false)
          }
        })

        // Tính tổng discount của CẢ ĐƠN trước khi áp dụng BTT-BSN
        const totalDiscountBeforeBTT = sumBy(Object.values(originalResultMap), 'discount')

        // // Áp dụng thử discount cho các item bánh trung thu
        // clonedItems.forEach(item => {
        //   const workName = get(item, 'productCatWorkName')
        //   if (workName !== 'Bánh trung thu' && !mooncake2025Skus.includes(item.sku)) {
        //     return
        //   }

        //   const soldPrice = getItemSoldPrice({
        //     item,
        //     orderPlatform: this.orderPlatform,
        //     orderType: this.orderType
        //   })

        //   // Áp dụng discount vào resultMap
        //   resultMap[item.id].discount = (soldPrice * item.quantity * MAX_DISCOUNT_PERCENT) / 100
        //   resultMap[item.id].saleProgram = 'Giảm 50% BTT đơn mua trực tiếp từ 250k'
        //   resultMap[item.id].noLoyalty = true
        // })

        // Tính tổng discount của CẢ ĐƠN sau khi áp dụng BTT-BSN
        const totalDiscountAfterBTT = sumBy(
          this.items.map(item => get(resultMap[item.id], 'discount', 0))
        )

        // const currentTotalValue = this.items.reduce((result, item) => {
        //   // if (mooncake2025Skus.includes(item.sku)) {
        //   //   return result
        //   // }
        //   const itemValue =
        //     item.quantity *
        //       getItemSoldPrice({
        //         item,
        //         orderPlatform: this.orderPlatform,
        //         orderType: this.orderType,
        //         withoutModifier: false,
        //         totalForDiscount: true
        //       }) -
        //     get(resultMap[item.id], 'discount', 0)
        //   return itemValue + result
        // }, 0)

        // So sánh tổng discount CẢ ĐƠN và quyết định giữ hay không
        if (totalDiscountAfterBTT > totalDiscountBeforeBTT) {
          // Giữ discount mới (đã áp dụng ở trên)
          console.log(
            '[BTT-BSN] Áp dụng discount BTT-BSN (tổng cả đơn tốt hơn):',
            totalDiscountAfterBTT,
            '> trước:',
            totalDiscountBeforeBTT
          )
        } else {
          // Khôi phục lại discount cũ cho TẤT CẢ items
          Object.keys(originalResultMap).forEach(itemId => {
            resultMap[itemId] = originalResultMap[itemId]
          })
          if (totalDiscountAfterBTT + totalDiscountBeforeBTT > 0) {
            console.log(
              '[BTT-BSN] Giữ discount cũ (tổng cả đơn không tốt hơn):',
              totalDiscountAfterBTT,
              '<= trước:',
              totalDiscountBeforeBTT
            )
          }
        }
      }
      // --- End Mooncake ---

      // Giảm giá cho khách hàng thân thiết - Savor Bread
      if (this.customer && get(this.computedCustomer, 'boughtSavorStoreSalesMap')) {
        const salePriceMap = { V9084: 10000, V2861: 20000 }
        const skus = keys(salePriceMap)
        const boughtMap: { [key: string]: any } = get(
          this.computedCustomer,
          'boughtSavorStoreSalesMap',
          {}
        )
        this.items.forEach(item => {
          if (!includes(skus, item.sku)) {
            return item
          }
          const boughtQty = boughtMap[item.sku] || 0
          if (boughtQty >= 2) {
            return item
          }
          const discountQty = Math.min(boughtQty ? 2 - boughtQty : 2, item.quantity)
          const basePrice = getPlatformPrice(item, this.orderPlatform)

          resultMap[item.id].discount = (basePrice - get(salePriceMap, item.sku)) * discountQty
          resultMap[item.id].saleProgram = 'Giảm giá cho khách hàng thân thiết'
          resultMap[item.id].noLoyalty = true
        })
      }

      // Sale Panna Cotta
      const pannaCottaSkus = ['V8581', 'V8579', 'V8577', 'V8571', 'V8573', 'V8575', 'V8594']
      if (isAfter(deliverDeadline, new Date('2024-09-24T00:00:00+07:00'))) {
        //  sale cho đến khi bếp hết nguyên liệu báo dừng nhận đơn

        _.forEach(this.items, item => {
          if (!_.includes(pannaCottaSkus, item.sku)) {
            return
          }
          const basePrice = getPlatformPrice(item, this.orderPlatform)
          resultMap[item.id].discount = ((basePrice * 20) / 100) * item.quantity
          resultMap[item.id].saleProgram = 'Flashsale Panna Cotta'
          resultMap[item.id].noLoyalty = true
        })
      }

      // Sale truffle
      const truffleValidCreated =
        !this.onlineOrder ||
        isAfter(get(this.onlineOrder, 'created'), new Date('2025-03-06T00:00:00+07:00'))
      if (truffleValidCreated && isBefore(deliverDeadline, new Date('2025-03-09T00:00:00+07:00'))) {
        _.forEach(this.items, item => {
          if (!_.includes(['V2204', 'V2205'], item.sku)) {
            return
          }
          const basePrice = getPlatformPrice(item, this.orderPlatform)
          resultMap[item.id].discount =
            (basePrice - (item.sku === 'V2204' ? 89000 : 99000)) * item.quantity
          resultMap[item.id].saleProgram = 'Giảm giá truffle'
          resultMap[item.id].noLoyalty = true
        })
      }
    } // END SAVOR_SHOP SALE

    if (this.orderPlatform === 'GRAB_FOOD') {
      const isJuneSale =
        isAfter(new Date(), new Date('2024-06-03T00:00:00+07:00')) &&
        isBefore(new Date(), new Date('2024-07-01T00:00:00+07:00'))
      if (isJuneSale && this.couponCode === 'HOT_PREVENTION') {
        let maxDiscountQty = 1
        this.items.forEach(item => {
          // V2329 Trà Ô Long nhài sữa trân châu (M)
          if (!maxDiscountQty || item.sku !== 'V2329') {
            return
          }
          const basePrice = getPlatformPrice(item, this.orderPlatform)
          resultMap[item.id].discount = (basePrice * 50) / 100
          resultMap[item.id].saleProgram = 'Phòng Nóng Chống Nóng - Giảm giá 50%'
          resultMap[item.id].noLoyalty = true
          maxDiscountQty -= 1
        })
      }
      if (isJuneSale && this.couponCode === 'CUISINE_GOLDEN_WEEK') {
        let maxDiscountQty = 1
        const totalValue = getSubTOtalWithoutPricedGift(
          this.items,
          this.orderPlatform,
          this.orderType
        )
        if (totalValue >= 150000) {
          this.items.forEach(item => {
            // V0608 Trà sữa TCDD size M
            if (!maxDiscountQty || item.sku !== 'V0608') {
              return
            }
            const basePrice = getPlatformPrice(item, this.orderPlatform)
            resultMap[item.id].discount = basePrice
            resultMap[item.id].saleProgram = 'Cuisine Week - Tuần Lễ Vàng - Tặng món 30k'
            resultMap[item.id].noLoyalty = true
            maxDiscountQty -= 1
          })
        }
      }
    }

    if (this.orderPlatform === 'NOW') {
      if (this.couponCode === 'FLASH_SALE_25_PERCENT') {
        const frameV9093 =
          isAfter(new Date(), new Date('2024-08-05T00:00:00+07:00')) &&
          isBefore(new Date(), new Date('2024-08-13T00:00:00+07:00'))

        const frameV9094 =
          dayStringBetween('2024-08-05T00:00:00+07:00', '2024-08-08T00:00:00+07:00') ||
          dayStringBetween('2024-08-09T00:00:00+07:00', '2024-08-10T00:00:00+07:00') ||
          dayStringBetween('2024-08-12T00:00:00+07:00', '2024-08-13T00:00:00+07:00')
        this.items.forEach(item => {
          if (!['V9093', 'V9094'].includes(item.sku)) {
            return
          }
          if (!frameV9093 && item.sku === 'V9093') {
            return
          }
          if (!frameV9094 && item.sku === 'V9094') {
            return
          }
          const basePrice = getPlatformPrice(item, this.orderPlatform)
          resultMap[item.id].discount = (basePrice * 25) / 100
          resultMap[item.id].saleProgram = 'Flash Sale 25%'
          resultMap[item.id].noLoyalty = true
        })
      }
      if (
        isAfter(new Date(), new Date('2024-01-18T00:00:00+07:00')) &&
        isBefore(new Date(), new Date('2024-02-01T00:00:00+07:00')) &&
        this.couponCode === 'SPF_TNMO_50%'
      ) {
        this.items.forEach(item => {
          if (item.sku !== 'V0287') {
            return
          }
          const basePrice = getPlatformPrice(item, this.orderPlatform)
          resultMap[item.id].discount = (basePrice - 17500) * item.quantity
          resultMap[item.id].saleProgram = 'SPF Sale 50% Bánh mì TNMO'
          resultMap[item.id].noLoyalty = true
        })
      }

      const saleBannerDay =
        isAfter(new Date(), new Date('2024-03-12T00:00:00+07:00')) &&
        isBefore(new Date(), new Date('2024-03-15T00:00:00+07:00'))
      if (saleBannerDay && this.couponCode === 'SAVOR40K') {
        this.items.forEach(item => {
          // V2471 Bánh mì thịt nướng mật ong + Trà Ô long kim quất giá gốc 50k
          // V9916 Bánh mì gà sốt teriyaki + Trà Ô long chanh leo giá gốc giá gốc 45k
          // V8311 Combo bánh mì thịt nướng mật ong (to) + cafe sữa đá (ShopeeFood) giá gốc 50k
          if (!['V2471', 'V9916', 'V8311'].includes(item.sku)) {
            return
          }
          const basePrice = getPlatformPrice(item, this.orderPlatform)
          resultMap[item.id].discount = (basePrice - 10000) * item.quantity
          resultMap[item.id].saleProgram = 'Special Banner'
          resultMap[item.id].noLoyalty = true
        })
      }
      const saleHalfDay =
        isAfter(new Date(), new Date('2023-12-12T00:00:00+07:00')) &&
        isBefore(new Date(), new Date('2023-12-13T00:00:00+07:00'))
      if (saleHalfDay && this.couponCode === 'SPF_COMBO_50%') {
        this.items.forEach(item => {
          // V2471 Bánh mì thịt nướng mật ong + Trà Ô long kim quất giá gốc 50k
          // V9916 Bánh mì gà sốt teriyaki + Trà Ô long chanh leo giá gốc giá gốc 45k
          if (item.sku !== 'V2471') {
            return
          }
          const basePrice = getPlatformPrice(item, this.orderPlatform)
          resultMap[item.id].discount = (basePrice - 25000) * item.quantity
          resultMap[item.id].saleProgram = 'SPF Sale 50% Combo'
          resultMap[item.id].noLoyalty = true
        })
      }

      if (
        isAfter(new Date(), new Date('2023-08-01T00:00:00+07:00')) &&
        isBefore(new Date(), new Date('2023-08-09T00:00:00+07:00'))
      ) {
        this.items.forEach(item => {
          // V0695 hồng trà sữa M
          if (item.sku !== 'V0695') {
            return
          }
          const soldPriceWithoutModifier = getItemSoldPrice({
            item,
            orderPlatform: this.orderPlatform,
            orderType: this.orderType,
            withoutModifier: true
          })
          resultMap[item.id].discount = (soldPriceWithoutModifier - 8000) * item.quantity
          resultMap[item.id].saleProgram = 'Flat 8k'
          resultMap[item.id].noLoyalty = true
        })
      }

      if (
        isAfter(new Date(), new Date('2023-08-01T00:00:00+07:00')) &&
        isBefore(new Date(), new Date('2023-09-01T00:00:00+07:00'))
      ) {
        // V0096 Bánh mì gà sốt teriyaki
        // V0287 Bánh mì thịt nướng mật ong
        // V2331 Trà Ô Long chanh leo (M)
        const weekday = new Date().getDay()
        if ([3, 4].includes(weekday)) {
          this.items.forEach(item => {
            if (!['V0096', 'V2331', 'V0287'].includes(item.sku)) {
              return
            }
            // chỉ sale thứ 4
            if (['V0096'].includes(item.sku) && weekday !== 3) {
              return
            }
            // chỉ sale thứ 5
            if (['V0287'].includes(item.sku) && weekday !== 4) {
              return
            }
            const basePrice = getPlatformPrice(item, this.orderPlatform)
            resultMap[item.id].discount = basePrice * 0.5 * item.quantity
            resultMap[item.id].saleProgram = 'Flash sale 50%'
            resultMap[item.id].noLoyalty = true
          })
        }
      }

      // if (
      //   this.couponCode === 'DAILY_FLASH_SALE' &&
      //   isBefore(new Date(), new Date('2023-01-01T00:00:00+07:00'))
      // ) {
      //   const weekday = new Date().getDay()
      //   const outlet = this.rootStore.authenticationStore.canUseCurrentOutlet
      //     ? getObjectId(
      //         this.rootStore.currentShiftStore.currentOutlet ||
      //           this.rootStore.currentShiftStore.currentShift!.outlet
      //       )
      //     : getObjectId(this.rootStore.currentShiftStore.currentShift!.outlet)
      //   if ([0, 6].includes(weekday) && !['S6', 'S2'].includes(get(outlet, 'code'))) {
      //     this.items.forEach(item => {
      //       if (['V0710', 'V1805'].includes(item.sku)) {
      //         const basePrice = getPlatformPrice(item, this.orderPlatform)
      //         resultMap[item.id].discount = basePrice * 0.5 * item.quantity
      //       }
      //     })
      //   }
      // }

      // end shopee food - now
    }

    if (this.couponCode === 'LOSHIP_DEAL' && this.orderPlatform === 'LOSHIP') {
      this.items.forEach(item => {
        if (item.category === 'bread') {
          const soldPrice = getItemSoldPrice({
            item,
            orderPlatform: this.orderPlatform,
            orderType: this.orderType
          })
          const newPrice = 15000
          const discount = (soldPrice - newPrice) * item.quantity
          resultMap[item.id].discount = discount
          resultMap[item.id].saleProgram = 'Chiết khấu bánh mì cho Loship'
          resultMap[item.id].noLoyalty = true
        }
      })
    } else if (
      this.orderPlatform === 'LALAMOVE' &&
      isAfter(new Date(), new Date('2020-11-27T23:59:59+07:00')) &&
      isBefore(new Date(), new Date('2020-11-30T00:00:00+07:00'))
    ) {
      this.items.forEach(item => {
        if (item.sku === 'V1031') {
          const soldPrice = getItemSoldPrice({
            item,
            orderPlatform: this.orderPlatform,
            orderType: this.orderType
          })

          const discount = (soldPrice - 5000) * item.quantity
          resultMap[item.id].discount = discount
          resultMap[item.id].saleProgram = 'Giảm giá bánh mì xúc xích cho tài xế Lalamove'
          resultMap[item.id].noLoyalty = true
        }
      })
    }

    // Apply round cake su kem promotion
    if (this.orderPlatform === 'SAVOR_SHOP') {
      // Check if promotion is active (starts August 1, 2025)
      const promotionStartDate = new Date('2025-07-31T00:00:00+07:00')
      const now = new Date()

      const promotionEndDate = new Date('2026-03-18T00:00:00+07:00')

      if (now > promotionStartDate && now < promotionEndDate) {
        // Define excluded subCats for round cakes (using subCatWorkName like ERP)
        const excludedSubCats = [
          'Bánh cốc',
          'Bánh su kem Singapore',
          'Bánh cupcake',
          'Bánh kem sự kiện',
          'Bánh hộp thiếc'
        ]

        // Count round cakes (birthday cakes that are not in excluded subCats)
        let roundCakeCount = 0
        this.items.forEach(item => {
          if (item.category === 'birthday-cake') {
            const isRoundCake =
              item.subCatWorkName && !includes(excludedSubCats, item.subCatWorkName)

            if (isRoundCake) {
              roundCakeCount += item.quantity
            }
          }
        })

        if (roundCakeCount > 0) {
          // Find su kem items (V8993, V9115) and apply discount
          const suKemSkus = ['V8993', 'V9115']

          // Maximum promotional boxes: 2 (as long as there are round cakes)
          let remainingPromotionalBoxes = 2

          this.items.forEach(item => {
            if (!includes(suKemSkus, item.sku) || remainingPromotionalBoxes <= 0) {
              return
            }

            // Calculate how many boxes can get the promotion
            const promotionalQuantity = Math.min(item.quantity, remainingPromotionalBoxes)

            if (promotionalQuantity > 0) {
              // Calculate discount: original price - 99,000 per box
              const soldPrice = getItemSoldPrice({
                item,
                orderPlatform: this.orderPlatform,
                orderType: this.orderType
              })
              const discountPerBox = soldPrice - 99000

              if (discountPerBox > 0) {
                const discountAmount = discountPerBox * promotionalQuantity
                resultMap[item.id].discount += discountAmount
                resultMap[item.id].saleProgram = 'Khuyến mãi bánh sinh nhật tròn - Su kem 99k'
                remainingPromotionalBoxes -= promotionalQuantity
              }
            }
          })
        }
      }
    }

    // Chương trình sale Set quà 8/3: mua bánh kèm set quà 99k
    processSetQua83Sale({
      items: this.items,
      resultMap,
      orderPlatform: this.orderPlatform,
      orderType: this.orderType
    })

    // Chương trình mua 3 tính tiền 2 8/3/2026
    processBuy3Pay2Sale({
      items: this.items,
      resultMap,
      orderPlatform: this.orderPlatform,
      orderType: this.orderType
    })

    // Chương trình đồng giá 99k su kem (V8993 + V9115)
    processFlat99kSale({
      items: this.items,
      resultMap,
      orderPlatform: this.orderPlatform,
      orderType: this.orderType
    })

    // Chương trình mua 1 tặng 1 (V10730 + V10176) - cơ sở E9, S6, B7, E62
    processBuy2Pay1Sale({
      items: this.items,
      resultMap,
      orderPlatform: this.orderPlatform,
      orderType: this.orderType,
      outletCode: this.getOutletCode()
    })

    // Chương trình sale Socola 8/3/2026
    // processChocolateMarch2026Sale({
    //   items: this.items,
    //   resultMap,
    //   orderPlatform: this.orderPlatform,
    //   orderType: this.orderType
    // })

    // Chương trình giảm giá 30k bánh Tiramisu sinh nhật (27/3/2026 - 10/5/2026)
    processTiramisuBirthdayCakeDiscount({
      items: this.items,
      resultMap,
      deadline: deliverDeadline
    })

    // Chương trình sale mascarpone: 30k Tiramisu + bánh kem, 20k hộp thiếc (28/5 - 27/6/2026)
    processMascarponeDiscount({
      items: this.items,
      resultMap,
      deadline: deliverDeadline
    })

    // Chương trình Combo 2 bánh "Bắc Nam một nhà" (từ 7/4/2026)
    processComboBacNamMotNha({
      items: this.items,
      resultMap,
      orderPlatform: this.orderPlatform,
      orderType: this.orderType
    })

    return resultMap
  }

  get computedItems(): IComputedItem[] {
    let computedItems = this.items.map(item => {
      const selectedVariant = getSelectedVariant(item)
      const soldPrice = getItemSoldPrice({
        item,
        orderPlatform: this.orderPlatform,
        orderType: this.orderType
      })
      const originalPrice = getOriginalPrice(item, this.orderPlatform, this.orderType)
      const sku = selectedVariant ? selectedVariant.sku : item.sku
      const lineTotal = soldPrice * item.quantity
      const description = selectedVariant
        ? item.description + ' - ' + selectedVariant.description
        : item.description

      let programReminder = ''

      // if (this.orderPlatform === 'SAVOR_SHOP') {
      //   const program = this.getBuy1Get1Program(item)
      //   programReminder = get(program, 'reminder', '')
      // }

      // Determine if item is taxable
      const isTaxable = isTaxableCategory(item.productCatWorkName)
      let taxPercentage = 0
      if (isTaxable) {
        taxPercentage = item.productTaxPercentage || 0
      }

      const computedItem: IComputedItem = {
        ...item,
        soldPrice,
        originalPrice,
        lineTotal,
        sku,
        selectedVariant,
        description,
        programReminder,
        // productTaxPercentage already in item from addProductToItems
        taxPercentage // Store calculated tax percentage (currently = productTaxPercentage)
        // taxAmount will be calculated after discount
      }

      if (this.voucher && this.voucher.voucherType === 'STAFF_DISCOUNT') {
        computedItem.noLoyalty = true
      }

      const matchDiscountItem = this.discountItemMap[computedItem.id]
      if (matchDiscountItem) {
        computedItem.discount = matchDiscountItem.discount || 0
        computedItem.saleProgram = matchDiscountItem.saleProgram || ''
        if (matchDiscountItem.noLoyalty === true) {
          computedItem.noLoyalty = true
        }
      }
      if (item.onlineOrderDiscount && item.onlineOrderDiscount.discount > 0) {
        // ưu tiên discount từ erp trừ staff discount do có code xử lý riêng từ trước ở bên này rồi
        computedItem.discount = item.onlineOrderDiscount.discount
        computedItem.saleProgram =
          item.onlineOrderDiscount.saleProgram || 'Giảm giá theo online order'
      }

      // Apply item-level discount first
      computedItem.lineTotal -= computedItem.discount || 0

      // Calculate tax AFTER item discount
      // Phase 1: Tax per item (after item discount only)
      // Phase 2: Tax at order level (after all discounts)
      let taxAmount = 0
      if (taxPercentage > 0 && !this.requestInvoice) {
        // Only calculate item tax when NOT requesting invoice (same with current ERP cake order logic)
        taxAmount = (computedItem.lineTotal * taxPercentage) / 100
        computedItem.lineTotal += taxAmount // Add tax to final lineTotal
      }
      computedItem.taxAmount = taxAmount
      return computedItem
    })

    return computedItems
  }

  // Get tax amount for the order
  get taxAmount(): number {
    if (!this.requestInvoice) {
      // ! Tạm thời không có giảm trừ ngoài item-level với case ko xuất hóa đơn
      return 0
    }
    const subtotalAfterDiscounts = this.saleTotal
    const taxRate =
      (this.invoiceSource === INVOICE_SOURCE.HOUSEHOLD
        ? TAX_RATES.HOUSEHOLD_INVOICE
        : TAX_RATES.COMPANY_INVOICE) || TAX_RATES.DEFAULT
    return (subtotalAfterDiscounts * taxRate) / 100
  }

  // Get total with tax
  get totalWithTax(): number {
    if (!this.requestInvoice) {
      // ! Tạm thời không có giảm trừ ngoài item-level với case ko xuất hóa đơn, tax đã được tính vào item.lineTotal luôn
      return this.saleTotal
    }
    return this.saleTotal + this.taxAmount
  }

  // Check if order contains alcohol (for household invoice validation) - Phase 2
  // get hasAlcoholItems(): boolean {
  //   return orderContainsAlcohol(this.computedItems)
  // }

  // Check if household invoice can be used - Phase 2
  // get canUseHouseholdInvoice(): boolean {
  //   return canUseHouseholdInvoice(this.computedItems)
  // }

  // Set invoice request status - Phase 2
  // setRequestInvoice(value: boolean) {
  //   this.requestInvoice = value
  //   // Reset to company invoice if turning on and has alcohol
  //   if (value && this.invoiceSource === 'household' && !this.canUseHouseholdInvoice) {
  //     this.invoiceSource = 'company'
  //   }
  // }

  // Set invoice source type - Phase 2
  // setInvoiceSource(source: TInvoiceSource) {
  //   // Validate household invoice if it has alcohol
  //   if (source === 'household' && !this.canUseHouseholdInvoice) {
  //     console.warn('Cannot use household invoice for orders containing alcohol')
  //     return false
  //   }
  //   this.invoiceSource = source
  //   return true
  // }

  getPlatformDiscounts(orderPlatform: TOrderPlatform) {
    return partnerDiscounts.filter(discount => {
      return discount.orderPlatform === orderPlatform
    })
  }

  getPartnerDiscountAmount(matchDiscount: IPartnerDiscount) {
    let amount = matchDiscount.amount || 0
    if (matchDiscount.percentValue && matchDiscount.rate && matchDiscount.maxValue) {
      amount = Math.min(
        matchDiscount.maxValue,
        matchDiscount.percentValue * this.saleTotalForBillDiscount * matchDiscount.rate
      )
    }
    return amount
  }

  // Combined function for voucher validation and discount calculation
  calculateVoucherResult(
    voucher: IVoucher | null,
    items: IComputedItem[] | IOrderItem[],
    orderSubtotal?: number
  ): {
    discount: number
    errorMessage?: string
  } {
    console.log('🚀 ~ OrderStore ~ calculateVoucherResult ~ voucher:', voucher)
    // No voucher
    if (!voucher) {
      return { discount: 0 }
    }

    // Check if order is empty
    if (!items || items.length === 0) {
      return {
        discount: 0,
        errorMessage: 'Vui lòng thêm sản phẩm vào đơn hàng trước khi áp dụng voucher'
      }
    }

    // Calculate sale total from items
    const computedItems = items as IComputedItem[]
    const saleTotal =
      computedItems[0] && 'lineTotal' in computedItems[0]
        ? _.sumBy(computedItems, 'lineTotal')
        : this.subtotal
    const subtotal = orderSubtotal || saleTotal

    // Check outlet restrictions
    if (voucher.outlets && voucher.outlets.length > 0) {
      const currentOutletCode = this.getOutletCode()
      const isOutletAllowed = voucher.outlets.some(outlet => {
        if (typeof outlet === 'string') {
          return outlet === currentOutletCode
        } else if (outlet && typeof outlet === 'object') {
          return outlet.code === currentOutletCode
        }
        return false
      })

      if (!isOutletAllowed) {
        return {
          discount: 0,
          errorMessage: 'Voucher này không áp dụng cho chi nhánh hiện tại'
        }
      }
    }

    // Check expiry date
    if (voucher.expiryDate && new Date(voucher.expiryDate) < new Date()) {
      return {
        discount: 0,
        errorMessage: 'Voucher này đã hết hạn'
      }
    }

    // Check start date
    // if (voucher.startDate && new Date(voucher.startDate) > new Date()) {
    //   return {
    //     discount: 0,
    //     errorMessage: `Voucher này chưa đến ngày sử dụng (bắt đầu từ ${new Date(
    //       voucher.startDate
    //     ).toLocaleDateString('vi-VN')})`
    //   }
    // }

    // Check minimum order value
    if (voucher.minValueOrder && voucher.minValueOrder > 0) {
      if (subtotal < voucher.minValueOrder) {
        return {
          discount: 0,
          errorMessage: `Đơn hàng phải có giá trị tối thiểu ${voucher.minValueOrder.toLocaleString(
            'vi-VN'
          )}đ để sử dụng voucher này`
        }
      }
    }

    // Calculate discount based on voucher type
    let discount = 0

    // Handle percentage-based vouchers
    if (_.get(voucher, 'voucherType') === 'DISCOUNT_CAKE_ORDER_10_PERCENT' && voucher.quantity) {
      discount = (saleTotal * voucher.quantity) / 100
      return { discount }
    }

    if (_.get(voucher, 'voucherType') === 'PERCENTAGE_TOTAL_WITHOUT_SHIP' && voucher.quantity) {
      discount = Math.round((saleTotal * voucher.quantity) / 100)
      const maxDiscountAmount = _.get(voucher, 'maxDiscountAmount', 0)
      if (maxDiscountAmount) {
        discount = Math.min(discount, maxDiscountAmount)
      }
      return { discount }
    }

    if (_.get(voucher, 'voucherType') === 'DISCOUNT_BREAD_ORDER_BY_PERCENT' && voucher.quantity) {
      const saleTotalNotSetTet = _.sumBy(computedItems, (item: any) => {
        if (
          item.description &&
          item.description.match(/Set quà/) &&
          item.category === 'banh-keo-tet'
        ) {
          return 0
        }
        return item.lineTotal || 0
      })
      discount = Math.min((saleTotalNotSetTet * voucher.quantity) / 100, 50000)
      return { discount }
    }

    if (
      _.get(voucher, 'voucherType') === 'DISCOUNT_CAKE_TET_ORDER_BY_PERCENT' &&
      voucher.quantity
    ) {
      const saleTotalSetTet = _.sumBy(computedItems, (item: any) => {
        if (
          item.description &&
          item.description.match(/Set quà/) &&
          item.category === 'banh-keo-tet'
        ) {
          return item.lineTotal || 0
        }
        return 0
      })
      discount = (saleTotalSetTet * voucher.quantity) / 100
      return { discount }
    }

    // Handle DISCOUNT_CAKE_BY_PRODUCT
    if (voucher.voucherType === 'DISCOUNT_CAKE_BY_PRODUCT' && voucher.saleProducts) {
      const saleProductSkus = voucher.saleProducts.map(sp => sp.sku).filter(Boolean)
      const matchingItems = (items as any[]).filter(item => saleProductSkus.includes(item.sku))

      if (matchingItems.length === 0) {
        return {
          discount: 0,
          errorMessage:
            'Voucher này chỉ áp dụng cho các sản phẩm: ' +
            voucher.saleProducts.map(sp => sp.description || sp.sku).join(', ')
        }
      }

      // Priority 1: Use voucher.quantity as fixed amount
      if (voucher.quantity && voucher.quantity > 0) {
        discount = voucher.quantity
      }
      // Priority 2: Use saleProduct.discountPrice per item
      else {
        discount = _.sumBy(matchingItems, item => {
          const saleProduct = voucher.saleProducts!.find(sp => sp.sku === item.sku)
          if (saleProduct && saleProduct.discountPrice) {
            return saleProduct.discountPrice * item.quantity
          }
          return 0
        })
      }
      return { discount }
    }

    // Handle DISCOUNT_CAKE_BY_PRODUCT_CAT
    if (voucher.voucherType === 'DISCOUNT_CAKE_BY_PRODUCT_CAT' && voucher.saleProductCats) {
      const voucherCategoryNames = voucher.saleProductCats.map(cat => cat.name).filter(Boolean)

      if (voucherCategoryNames.length > 0) {
        const hasMatchingCategory = (items as any[]).some(item => {
          if (!item.productCatWorkName) return false
          return voucherCategoryNames.includes(item.productCatWorkName)
        })

        if (!hasMatchingCategory) {
          return {
            discount: 0,
            errorMessage:
              'Voucher này chỉ áp dụng cho danh mục: ' +
              voucher.saleProductCats.map(cat => cat.name || cat.productCat).join(', ')
          }
        }
      }

      discount = voucher.quantity || voucher.amount || 0
      return { discount }
    }

    // Default: use quantity or amount
    discount = voucher.quantity || voucher.amount || 0
    return { discount }
  }

  // Backward compatibility wrapper
  getVoucherDiscount(voucher: IVoucher, items: IComputedItem[]) {
    const result = this.calculateVoucherResult(voucher, items)
    return result.discount
  }

  get discounts(): IDiscount[] {
    const discounts: IDiscount[] = []
    const platformDiscounts = this.getPlatformDiscounts(this.orderPlatform)
    if (this.voucher && this.voucher.voucherType !== 'NONE') {
      switch (this.voucher.voucherType) {
        case 'OPENING_20_PERCENT':
          discounts.push({
            description: 'Giảm giá khai trương 20%',
            amount: Math.floor((this.withoutDiscountsSubTotal * 20) / 100)
          })
          break
        case 'STAFF_DISCOUNT':
          const percent = this.getPercentDiscount()
          const staffDiscount = getStaffDiscountByBusiness({
            breadDiscount: get(this.computedCustomer, 'discountStaffSavorBread', false),
            cakeDiscount: get(this.computedCustomer, 'discountStaffSavorCake', false),
            percent,
            items: this.items,
            orderPlatform: this.orderPlatform,
            orderType: this.orderType,
            discountItemMap: this.discountItemMap
          })
          discounts.push({
            description: 'Giảm giá nhân viên',
            amount: staffDiscount
          })
          break
        case 'AMOUNT':
          discounts.push({
            description: this.voucher.name,
            amount: this.voucher.amount || this.voucher.quantity || 0
          })
          break
        case 'VOUCHER_50K':
          discounts.push({
            description: this.voucher.name,
            amount: 50000
          })
          break
        case 'DISCOUNT_CAKE_ORDER':
        case 'DISCOUNT_CAKE_ORDER_BIG':
        case 'DISCOUNT_CAKE_ORDER_NORMAL':
        case 'DISCOUNT_CAKE_ORDER_10_PERCENT':
        case 'DISCOUNT_BREAD_ORDER_BY_PERCENT':
        case 'DISCOUNT_CAKE_TET_ORDER_BY_PERCENT':
        case 'DISCOUNT_CAKE_BY_PRODUCT':
        case 'DISCOUNT_CAKE_BY_PRODUCT_CAT':
        case 'PERCENTAGE_TOTAL_WITHOUT_SHIP':
          discounts.push({
            description: `${this.voucher.name} ${
              this.voucher.couponCode ? `(${this.voucher.couponCode})` : ''
            }`,
            amount: this.getVoucherDiscount(this.voucher, this.computedItems)
          })
          break
      }
      const matchDiscount = platformDiscounts.find(discount => {
        const voucher = this.voucher ? this.voucher.voucherType : ''
        return discount.code === voucher
      })
      if (matchDiscount && this.saleTotalForBillDiscount >= matchDiscount.minValue) {
        const inValidTime =
          matchDiscount.start && matchDiscount.end
            ? isAfter(new Date(), new Date(matchDiscount.start)) &&
              isBefore(new Date(), new Date(matchDiscount.end))
            : false
        const notCheckTime = !matchDiscount.start && !matchDiscount.end
        if (notCheckTime || inValidTime) {
          discounts.push({
            description: `Giảm giá đơn hàng ${this.orderPlatform} áp dụng voucher ${matchDiscount.code}`,
            amount: this.getPartnerDiscountAmount(matchDiscount)
          })
        }
      }
    }
    return discounts
  }

  get withoutDiscountsSubTotal(): number {
    return this.items.reduce((result, item) => {
      if (item.sku !== 'V1408' && getItemDiscount(item, this.discountItemMap) > 0) {
        return result
      }
      const soldPrice = getItemSoldPrice({
        item,
        orderPlatform: this.orderPlatform,
        orderType: this.orderType
      })
      return result + soldPrice * item.quantity
    }, 0)
  }
  get saleTotalForBillDiscount(): number {
    return this.items.reduce((result, item) => {
      const soldPrice = getItemSoldPrice({
        item,
        orderPlatform: this.orderPlatform,
        orderType: this.orderType
      })
      return result + soldPrice * item.quantity - getItemDiscount(item, this.discountItemMap)
    }, 0)
  }

  get subtotal(): number {
    const total = this.computedItems.reduce((result, item) => {
      return item.lineTotal + result
    }, 0)
    if (process.env.NODE_ENV === 'development') {
      console.log('=== Subtotal Calculation ===')
      console.log('Computed items count:', this.computedItems.length)
      console.log('Subtotal value:', total)
    }
    return total
  }
  get discountTotal(): number {
    return this.discounts.reduce((result, discount) => {
      return result + discount.amount
    }, 0)
  }
  get saleTotal(): number {
    return Math.max(this.subtotal - this.discountTotal, 0)
  }

  get cashTotal(): number {
    return (
      this.saleTotal -
      this.shippingPay +
      this.shippingCollect -
      this.computedReceivableAmount -
      this.commissionAmount -
      this.deposit
    )
  }

  get toCollectAmount(): number {
    return (
      this.saleTotal -
      this.shippingPay +
      this.shippingCollect -
      this.commissionAmount -
      this.deposit
    )
  }

  get isPendingCustomerCard(): boolean {
    return Boolean(
      this.computedCustomer &&
      this.computedCustomer.registerTime &&
      isBefore(
        startOfDay(new Date()),
        addDays(startOfDay(new Date(this.computedCustomer.registerTime)), 1)
      )
    )
  }

  get customerCardStage(): TCustomerCardStage {
    if (!this.computedCustomer) {
      return 'no customer'
    }
    if (!this.computedCustomer.registered || !this.computedCustomer.registerTime) {
      return 'not registered'
    }
    if (this.isPendingCustomerCard) {
      return 'not activated'
    }
    return 'activated'
  }

  get availableVouchers(): IVoucher[] {
    let vouchers = [...(this.computedCustomer ? this.computedCustomer.vouchers || [] : [])]
    if (
      !this.computedCustomer ||
      !this.computedCustomer.registered ||
      !this.computedCustomer.registerTime ||
      this.isPendingCustomerCard
    ) {
      vouchers = vouchers.filter(voucher => voucher.withoutCard)
    }
    const platformDiscounts = this.getPlatformDiscounts(this.orderPlatform)
    const matchDiscount = platformDiscounts.find(discount => discount.code === this.voucherCode)
    if (
      !matchDiscount &&
      this.voucherCode &&
      !['NONE', 'OPENING_20_PERCENT'].includes(this.voucherCode)
    ) {
      toast.error(
        `Mã ${this.voucherCode} không tồn tại. Vui lòng check lại đơn đối tác hoặc báo team TECH nhé`
      )
      return vouchers
    }
    if (matchDiscount) {
      if (this.saleTotalForBillDiscount < matchDiscount.minValue) {
        toast.error('Không đủ điều kiện áp mã giảm giá')
        return vouchers
      }
      vouchers.unshift({
        _id: ObjectId(),
        name: `Giảm giá ${this.orderPlatform}`,
        voucherType: matchDiscount.code,
        amount: this.getPartnerDiscountAmount(matchDiscount)
      })
    }

    // if (vouchers.length || showDiscountOpenS17) {
    //   vouchers.push({
    //     _id: ObjectId(),
    //     name: 'Không sử dụng',
    //     voucherType: 'NONE',
    //     amount: 0
    //   })
    // }
    if (
      this.computedCustomer &&
      this.computedCustomer.isStaff &&
      !some(get(this.onlineOrder, 'items', []), item => {
        return ['V2204', 'V2205'].includes(item.sku)
      }) &&
      (this.computedCustomer.discountStaffSavorBread ||
        this.computedCustomer.discountStaffSavorCake)
    ) {
      const percent = this.getPercentDiscount()

      const staffDiscount = getStaffDiscountByBusiness({
        breadDiscount: get(this.computedCustomer, 'discountStaffSavorBread', false),
        cakeDiscount: get(this.computedCustomer, 'discountStaffSavorCake', false),
        percent,
        items: this.items,
        orderPlatform: this.orderPlatform,
        orderType: this.orderType,
        discountItemMap: this.discountItemMap
      })
      const discountObj: IVoucher = {
        _id: ObjectId(),
        name: 'Giảm giá nhân viên',
        voucherType: 'STAFF_DISCOUNT',
        amount: staffDiscount
      }
      vouchers.unshift(discountObj)
      // ! đoạn code bị cmt dưới gây lỗi giảm giá nv: iterations quá nhiều lần
      // if (!this.voucher) {
      //   vouchers.unshift(discountObj)
      // } else if (['NONE', 'STAFF_DISCOUNT'].includes(this.voucher.voucherType)) {
      //   vouchers.push(discountObj)
      // } else {
      //   vouchers.unshift(discountObj)
      // }
    }
    // if (showDiscountOpenS17) {
    //   const discountOpening: IVoucher = {
    //     _id: ObjectId(),
    //     name: 'Giảm giá khai trương 20%',
    //     voucherType: 'OPENING_20_PERCENT',
    //     amount: Math.floor((this.withoutDiscountsSubTotal * 20) / 100)
    //   }
    //   if (!this.voucher) {
    //     vouchers.unshift(discountOpening)
    //   } else if (['NONE', 'STAFF_DISCOUNT'].includes(this.voucher.voucherType)) {
    //     vouchers.push(discountOpening)
    //   } else {
    //     vouchers.unshift(discountOpening)
    //   }
    // }

    // if (!vouchers.length && this.voucher) {
    //   vouchers = [this.voucher]
    // }
    if (vouchers.length) {
      vouchers.push({
        _id: ObjectId(),
        name: 'Không sử dụng',
        voucherType: 'NONE',
        amount: 0
      })
    }

    return vouchers
  }

  async updateOrder() {
    if (!this.rootStore.currentShiftStore.loggedInShift) {
      throw new Error('Không thể cập nhật đơn khi chưa đăng nhập vào ca trực')
    }

    const updatedOrder: any = {
      orderId: this.orderId,
      items: this.items,
      customer: this.customer,
      computedCustomer: this.computedCustomer,
      voucher: this.voucher,
      orderPlatform: this.orderPlatform,
      payments: this.payments,
      shippingProvider: this.shippingProvider,
      shippingPay: this.shippingPay,
      couponCode: this.couponCode,
      shippingBillNumber: this.shippingBillNumber,
      shippingPaymentMethod: this.shippingPaymentMethod,
      shippingCustomerName: this.shippingCustomerName,
      shippingCustomerPhone: this.shippingCustomerPhone,
      shippingCustomerAddress: this.shippingCustomerAddress,
      onlineOrderId: this.onlineOrderId,
      status: this.status,
      ordered: this.ordered,
      updated: new Date(),
      discounts: this.discounts,
      shippingCollect: this.shippingCollect,
      computedItems: this.computedItems,
      discountItemMap: this.discountItemMap,
      subtotal: this.subtotal,
      discountTotal: this.discountTotal,
      saleTotal: this.saleTotal,
      deposit: this.deposit,
      availableVouchers: this.availableVouchers,
      cashTotal: this.cashTotal,
      computedReceivableAmount: this.computedReceivableAmount,
      computedReceiveAmount: this.computedReceiveAmount,
      commissionAmount: this.commissionAmount,
      commissionableAmount: this.commissionableAmount,
      commissionPercentage: this.commissionPercentage,
      isPendingCustomerCard: this.isPendingCustomerCard,
      serviceMode: this.computedServiceMode,
      customerCardStage: this.customerCardStage,
      subTotal: this.subtotal
    }

    try {
      await this.rootStore.agent.put('/orders/' + this._id, updatedOrder)
    } catch (e) {
      handleAgentErrorResponse(e)
    }
  }

  availableVouchersReaction = reaction(
    () => this.availableVouchers.map(voucher => voucher._id),
    () => {
      if (this.voucher) {
        if (this.onlineOrderId) {
          this.availableVouchers.push(this.voucher)
        }
        if (this.availableVouchers.length) {
          const matchVoucher = this.availableVouchers.find(
            voucher => voucher._id === (this.voucher ? this.voucher._id : '')
          )
          if (!matchVoucher) {
            this.voucher = null
          }
        } else {
          this.voucher = null
        }
      }

      // Only auto-select first voucher if user hasn't explicitly selected no voucher
      if (!this.voucher && this.availableVouchers.length && !this.userExplicitlySelectedNoVoucher) {
        const headVoucher = this.availableVouchers[0]
        if (this.validateVoucher(headVoucher)) {
          this.voucher = headVoucher
        }
      }
    }
  )

  addItem(item: IOrderItem) {
    if (item.sku === 'V0677' || item.sku === 'V0680') {
      // let giftSku = 'V0680'
      // let giftName = 'Quai vải Savor'
      // if (getHours(new Date()) >= 16) {
      //   giftSku = 'V0677'
      //   giftName = 'Bộ Savor Green'
      // }
      if (
        this.orderPlatform !== 'SAVOR_SHOP' ||
        !this.rootStore.currentShiftStore.currentShift ||
        !this.rootStore.currentShiftStore.currentShift.shiftRecordId.match(/S1/)
      ) {
        return toast.error(
          'Chỉ đơn hàng tại S1 mới được thêm sản phẩm V0677 Bộ Savor Green hoặc V0680 Quai Vải Savor'
        )
      } else if (
        some(this.items, item => {
          return ['V0677', 'V0680'].includes(item.sku)
        })
      ) {
        return toast.error('Mỗi đơn hàng chỉ được có 1 bộ Savor Green hoặc Quai vải')
      }
    }

    this.items.push(item)

    if (some(this.rootStore!.productStatusStore.products, { sku: item.sku, inStock: false })) {
      if (item.variants && item.variants.length > 0) {
        const otherVariant = item.variants.find(variant => variant.sku !== item.sku)
        otherVariant ? this.selectVariant(item, otherVariant) : undefined
      }
    }

    forEach(item.modifiers, modifier => {
      if (
        some(this.rootStore!.productStatusStore.products, {
          sku: modifier.sku,
          inStock: false
        })
      ) {
        this.removeModifier(item, modifier)
      }
    })
  }

  addProductToItems(product: IProduct) {
    const defaultModifiers = product.defaultModifierSkus
      ? flatten(
          product.defaultModifierSkus.map(sku => {
            return modifierStore.modifiers
              .filter(modifier => {
                return modifier.sku === sku
              })
              .map(modifier => ({ ...modifier, quantity: 1 }))
          })
        )
      : []

    this.addItem({
      ...product,
      id: `${Date.now()}`,
      quantity: product.quantity || 1,
      modifiers: defaultModifiers,
      noLoyalty: product.noLoyalty || false,
      productTaxPercentage: product.taxPercentage // Store original tax when adding to order
    })
  }

  selectProduct(product: IProduct) {
    const _product = cloneDeep(product)
    forEach(_product.comboElements, comboElement => {
      comboElement.selectedItem = undefined
    })

    this.product = product
  }
  removeProduct() {
    this.product = undefined
  }
  setNormalPrice(normalPrice: number) {
    if (!this.product) {
      return
    }
    this.product.normalPrice = normalPrice
  }

  selectVariant(item: IOrderItem, variant: IVariant) {
    const matchItem = this.items.find(_item => _item.id === item.id)
    if (!matchItem) return
    matchItem.selectedVariant = variant
  }

  selectItemOptionForCombo(comboElement: TComboElement, itemOption: { sku: string }) {
    if (!this.product) {
      return
    }
    const matchComboElement = this.product!.comboElements!.find(
      _comboElement => _comboElement.name === comboElement.name
    )
    if (!matchComboElement) return
    matchComboElement.selectedItem = itemOption
  }

  removeItem(item: IOrderItem) {
    if (item.isCombo) {
      item.comboElements!.forEach(comboElement => {
        const matchcComboElementIndex = this.items.findIndex(_item => _item.comboId === item.id)
        this.items.splice(matchcComboElementIndex, 1)
      })
    }
    const matchItemIndex = this.items.findIndex(_item => _item.id === item.id)
    this.items.splice(matchItemIndex, 1)
  }

  setCustomer(customer: ICustomer) {
    this.customer = customer
  }

  clearCustomer() {
    this.computedCustomer = null
    this.customer = null
    this.voucher = null
    this.userExplicitlySelectedNoVoucher = false
    this.isNewCustomerGiftDeclined = false
    this.isCustomerNoPhoneConfirmed = false
  }

  setNewCustomerGiftDeclined(value: boolean) {
    this.isNewCustomerGiftDeclined = value
  }

  setCustomerNoPhoneConfirmed(value: boolean) {
    this.isCustomerNoPhoneConfirmed = value
  }

  _setComputedCustomer(customer: ICustomer | null) {
    this.computedCustomer = customer
  }

  setVoucher(voucher: IVoucher | null) {
    console.log('=== setVoucher called ===')
    console.log('Voucher object:', JSON.stringify(voucher, null, 2))

    // Check if this is a "no voucher" selection (voucherType: "NONE")
    if (voucher && voucher.voucherType === 'NONE') {
      console.log('User selected "Không sử dụng" voucher, treating as no voucher')
      this.userExplicitlySelectedNoVoucher = true
      this.voucher = null
      return
    }

    // Track if user explicitly selected no voucher
    if (voucher === null) {
      this.userExplicitlySelectedNoVoucher = true
    } else {
      this.userExplicitlySelectedNoVoucher = false
    }

    // Validate voucher before setting
    if (voucher && !this.validateVoucher(voucher)) {
      console.log('Voucher validation failed')
      return
    }

    console.log('Voucher validation passed, setting voucher')
    this.voucher = voucher
  }

  validateVoucher(voucher: IVoucher): boolean {
    const result = this.calculateVoucherResult(voucher, this.computedItems, this.subtotal)

    if (result.discount <= 0 && result.errorMessage) {
      toast.error(result.errorMessage)
      return false
    }

    return result.discount > 0
  }

  customerReaction = reaction(
    () => {
      return this.customer ? this.customer._id : null
    },
    async () => {
      if (!this.customer || !this.customer._id) {
        this._setComputedCustomer(null)
        return
      }
      try {
        await this.checkVouchers(this.customer)
      } catch (e) {
        handleAgentErrorResponse(e)
      }
    }
  )

  autoUpdateReaction = reaction(
    () => {
      return {
        _id: this._id,
        items: toJS(this.items),
        computedCustomer: this.computedCustomer,
        voucher: this.voucher,
        orderPlatform: this.orderPlatform,
        payments: toJS(this.payments),
        shippingProvider: this.shippingProvider,
        shippingPay: this.shippingPay,
        shippingCollect: this.shippingCollect,
        couponCode: this.couponCode,
        shippingBillNumber: this.shippingBillNumber,
        shippingPaymentMethod: this.shippingPaymentMethod,
        shippingCustomerName: this.shippingCustomerName,
        shippingCustomerPhone: this.shippingCustomerPhone,
        shippingCustomerAddress: this.shippingCustomerAddress,
        onlineOrderId: this.onlineOrderId,
        status: this.status,
        selectedServiceMode: this.selectedServiceMode
      }
    },
    data => {
      if (!this.autosave) return
      this.updateOrder().catch(e => {
        handleAgentErrorResponse(e)
        this.rootStore.agent.get<IOrder>(`/orders/${data._id}`).then(order => {
          this.rootStore.listOrderStore.findAndUpdateOrder(order)
        })
      })
    }
  )

  async fetchPreOrderMooncakeQuantities() {
    try {
      const outletCode = this.getOutletCode()
      console.log('Fetching mooncake quantities for outlet:', outletCode)
      // Only fetch for B4 outlet (as per pre-order-batch configuration)
      if (outletCode !== 'B4') {
        console.log('Skipping fetch - not B4 outlet')
        return
      }

      // Fetch mooncake quantities from ERP (batch management is handled on ERP side)
      try {
        const now = new Date()
        // Use current date for fetching quantities
        const deliveryDate = now
        const deliveryDateStr = deliveryDate.toISOString().split('T')[0] // YYYY-MM-DD format

        // Let ERP determine which batch based on delivery date
        const response = await this.rootStore.agent.get<{
          quantities: { deo: number; nuong: number; combo: number }
          limits: { deo: number; nuong: number }
          remaining: { deo: number; nuong: number }
          batchFound: boolean
          batchId?: number
          batchName?: string
        }>(`/api_savor/online-orders/moon-cake-quantities?deliveryDate=${deliveryDateStr}`)

        console.log(`Response from ERP:`, response)

        if (response && response.quantities) {
          // Use batch info from response or default values
          const batchId = String(response.batchId || 'current')
          const batchName = response.batchName || 'Current Batch'

          const batchData = {
            [batchId]: response.quantities,
            activeBatchName: batchName,
            activeBatchId: batchId,
            limits: response.limits,
            remaining: response.remaining
          }

          console.log('Batch quantities:', batchData)

          runInAction(() => {
            this.preOrderMooncakeQuantities = batchData as any
          })
        }
      } catch (err) {
        console.error('Error fetching mooncake quantities:', err)
        runInAction(() => {
          this.preOrderMooncakeQuantities = null
        })
      }
    } catch (error) {
      console.error('Error fetching pre-order mooncake quantities:', error)
      // Không throw error để không ảnh hưởng flow load order
    }
  }

  async checkVouchers(customer: ICustomer) {
    const responseCustomer = await this.rootStore.agent.get<ICustomer>(
      `/customers/${customer.customerId}/value-vouchers/?business=SAVOR`
    )
    const vouchers =
      this.onlineOrderId && this.voucher
        ? [this.voucher]
        : (responseCustomer.vouchers || []).map(voucher => {
            return {
              ...voucher,
              amount: this.getVoucherDiscount(voucher, this.computedItems)
            }
          })
    this._setComputedCustomer({
      ...customer,
      customerPoints: responseCustomer.customerPoints,
      isStaff: responseCustomer.isStaff,
      numRemainDiscount: responseCustomer.numRemainDiscount,
      remainDiscountValue: responseCustomer.remainDiscountValue,
      drinkSkus: responseCustomer.drinkSkus,
      mooncakeSkus: responseCustomer.mooncakeSkus,
      mooncakePercent: responseCustomer.mooncakePercent,
      numRemainMooncakeDiscount: responseCustomer.numRemainMooncakeDiscount,
      tetCakeCandySkus: responseCustomer.tetCakeCandySkus,
      tetCakeCandyProducts: responseCustomer.tetCakeCandyProducts,
      tetCakeCandyPercent: responseCustomer.tetCakeCandyPercent,
      tetCakeCandyMaxDiscountTotal: responseCustomer.tetCakeCandyMaxDiscountTotal,
      boughtSavorStoreSalesMap: responseCustomer.boughtSavorStoreSalesMap,
      discountStaffSavorBread: responseCustomer.discountStaffSavorBread,
      discountStaffSavorCake: responseCustomer.discountStaffSavorCake,
      numSaleBread: responseCustomer.numSaleBread,
      numGiftedNationalDayCake: responseCustomer.numGiftedNationalDayCake,
      scakePremiumCutleryGiftResult: responseCustomer.scakePremiumCutleryGiftResult,
      mooncakeDiscountWithBirthdayCakeResult:
        responseCustomer.mooncakeDiscountWithBirthdayCakeResult,
      isNewSavorCakeGiftEligible: responseCustomer.isNewSavorCakeGiftEligible,
      vouchers
    })
  }

  changeItemQuantity(item: IOrderItem, quantity: number) {
    const matchItem = this.items.find(_item => _item.id === item.id)
    if (matchItem) {
      if (quantity === 0) {
        remove(this.items, matchItem)
      } else {
        matchItem.quantity = quantity
      }
    }
  }

  changeItemManufacturingDate(item: IOrderItem, date: Date) {
    const matchItem = this.items.find(_item => _item.id === item.id)
    if (matchItem) {
      matchItem.manufacturingDate = date
    }
  }
  changeItemNote(item: IOrderItem, note: string) {
    const matchItem = this.items.find(_item => _item.id === item.id)
    if (matchItem) {
      matchItem.note = note
    }
  }
  @action
  changeItemCanDiscount(item: IOrderItem, canDiscount: boolean) {
    const matchItem = this.items.find(_item => _item.id === item.id)
    if (matchItem) {
      matchItem.canDiscount = canDiscount
    }
  }

  addModifier(item: IOrderItem, modifier: IModifier) {
    const matchItem = this.items.find(_item => _item.id === item.id)

    if (!matchItem) {
      return
    }

    const modifierSet = modifierStore.modifierSets.find(
      modifierSet => modifierSet.code === modifier.modifierSetCode
    )

    if (modifierSet && modifierSet.maxTotalQuantity) {
      const totalModifierQuantity = item.modifiers
        .filter(modifier => {
          return modifier.modifierSetCode === modifierSet.code
        })
        .reduce((result, modifier) => {
          return result + modifier.quantity
        }, 0)

      if (totalModifierQuantity >= modifierSet.maxTotalQuantity) {
        if (modifierSet.maxTotalQuantity === 1) {
          matchItem.modifiers = matchItem.modifiers.filter(modifier => {
            return modifier.modifierSetCode !== modifierSet.code
          })
        } else {
          return `Lựa chọn ${modifierSet.name} vượt quá số lượng tối đa là ${modifierSet.maxTotalQuantity}`
        }
      }
    }

    const matchModifier = matchItem.modifiers.find(
      itemModifier => itemModifier.sku === modifier.sku
    )

    if (matchModifier) {
      if (modifier.maxQuantity) {
        if (matchModifier.quantity >= modifier.maxQuantity) {
          return `Lựa chọn ${modifier.description} vượt quá số lượng tối đa là ${modifier.maxQuantity}`
        }
      }
      matchModifier.quantity = matchModifier.quantity || 0
      matchModifier.quantity += 1
    } else {
      matchItem.modifiers.push({
        ...modifier,
        quantity: 1
      })
    }
  }

  subtractModifier(item: IOrderItem, modifier: IModifier) {
    const matchItem = this.items.find(_item => _item.id === item.id)

    if (!matchItem) {
      return
    }

    const matchModifier = matchItem.modifiers.find(
      itemModifier => itemModifier.sku === modifier.sku
    )
    if (matchModifier) {
      matchModifier.quantity = matchModifier.quantity || 0
      matchModifier.quantity -= 1
      if (matchModifier.quantity === 0) {
        remove(matchItem.modifiers, matchModifier)
      }
    } else {
      return
    }
  }

  removeModifier(item: IOrderItem, modifier: IModifier) {
    const matchItem = this.items.find(_item => _item.id === item.id)

    if (!matchItem) {
      return
    }

    const modifierSet = modifierStore.modifierSets.find(
      modifierSet => modifierSet.code === modifier.modifierSetCode
    )

    if (modifierSet && modifierSet.minTotalQuantity) {
      const totalModifierQuantity = item.modifiers
        .filter(modifier => {
          return modifier.modifierSetCode === modifierSet.code
        })
        .reduce((result, modifier) => {
          return result + modifier.quantity
        }, 0)
      if (totalModifierQuantity <= modifierSet.minTotalQuantity) {
        return
      }
    }

    const matchModifier = matchItem.modifiers.find(
      itemModifier => itemModifier.sku === modifier.sku
    )
    if (matchModifier) {
      remove(matchItem.modifiers, matchModifier)
    } else {
      return
    }
  }

  clearOrder() {
    this._id = ObjectId()
    this.shippingCustomerName = ''
    this.shippingCustomerPhone = ''
    this.shippingCustomerAddress = ''
    this.onlineOrderId = ''
    this.status = null
    this.ordered = undefined
    this.updated = undefined
    this.onlineOrder = undefined
    this.deposit = 0
    this.orderId = ''
    this.items = []
    this.customer = null
    this.computedCustomer = null
    this.voucher = null
    this.userExplicitlySelectedNoVoucher = false
    this.isNewCustomerGiftDeclined = false
    this.isCustomerNoPhoneConfirmed = false
    this.selectedOrderPlatform = 'SAVOR_SHOP'
    this.payments = []
    this.shippingProvider = null
    this.shippingPay = 0
    this.shippingCollect = 0
    this.couponCode = ''
    this.shippingBillNumber = ''
    this.shippingPaymentMethod = ''
    this.selectedServiceMode = ''
    this.openModalPayment = false
    this.saving = false
    this.receivedMoney = null
    this.nowOrderCode = ''
    this.momoTransId = ''
    this.orderCode = null
    this.goFoodPin = null
    this.transferCode = null
    this.headOrderCode = null
    this.tailOrderCode = null
    this.groupPaid = false
  }

  setSaving(status: boolean) {
    this.saving = status
  }

  // True khi đơn thuộc phạm vi bắt buộc nhập SĐT (bánh sinh nhật HN, từ 22/6 — WT #106468)
  // nhưng chưa có SĐT khách. Dùng để hiện checkbox "Khách không cho SĐT" cho cashier.
  get isNewCustomerCakeGiftPhoneRequired() {
    const inGiftWindow = isInNewCustomerCakeGiftWindow({
      items: this.items,
      region: this.getOutletRegion(),
      orderPlatform: this.orderPlatform,
      now: new Date()
    })
    return inGiftWindow && !get(this.computedCustomer, 'cellphone')
  }

  // Chương trình "Ưu đãi khách mới - đặt bánh có quà" (Savor Cake HN, từ 22/6) — WT #106468.
  // Throw nếu đơn khách mới chưa đủ điều kiện hoàn thành: (1) đơn bánh sinh nhật HN chưa
  // nhập SĐT khách (trừ khi cashier tích "Khách không cho SĐT"); (2) khách mới đủ điều kiện
  // nhưng chưa thêm phụ kiện tặng (trừ khi cashier tích "Khách không nhận quà"). Gọi cả lúc
  // mở modal thanh toán lẫn lúc validateOrder.
  assertNewCustomerCakeGiftRequirements() {
    const inGiftWindow = isInNewCustomerCakeGiftWindow({
      items: this.items,
      region: this.getOutletRegion(),
      orderPlatform: this.orderPlatform,
      now: new Date()
    })
    if (
      inGiftWindow &&
      !get(this.computedCustomer, 'cellphone') &&
      !this.isCustomerNoPhoneConfirmed
    ) {
      throw new Error(
        'Đơn bánh sinh nhật tại Hà Nội cần nhập SĐT khách để kiểm tra ưu đãi "Khách mới - đặt bánh có quà". Vui lòng chọn/nhập khách hàng (nút "Thẻ KH"), hoặc tích "Khách không cho SĐT" nếu khách từ chối, rồi hoàn thành đơn.'
      )
    }

    const newCustomerGiftEligibility = checkNewCustomerCakeGiftEligibility({
      customer: this.computedCustomer,
      items: this.items,
      region: this.getOutletRegion(),
      orderPlatform: this.orderPlatform,
      now: new Date()
    })
    if (
      newCustomerGiftEligibility.isEligible &&
      !this.isNewCustomerGiftDeclined &&
      !some(this.items, item => NEW_CUSTOMER_CAKE_GIFT_SKUS.includes(item.sku))
    ) {
      throw new Error(
        'Khách mới được tặng miễn phí 1 phụ kiện sinh nhật — vui lòng thêm phụ kiện khách chọn vào đơn, hoặc tích "Khách không nhận quà" nếu khách từ chối.'
      )
    }
  }

  validateOrder() {
    const outletCode = this.getOutletCode()

    // Validation cho chương trình tặng Bộ dao dĩa cao cấp
    const cutleryValidation = checkCutleryGiftEligibility({
      customer: this.computedCustomer,
      orderPlatform: this.orderPlatform,
      items: this.items,
      orderType: this.orderType
    })
    if (
      cutleryValidation.isEligible &&
      this.saleTotal < 200000 &&
      this.items.some(item => item.sku === 'V10089')
    ) {
      throw new Error(
        'Đơn Tặng Bộ dao dĩa cao cấp phải từ 200.000đ trở lên. Tổng đơn hiện tại là ' +
          this.saleTotal +
          'đ'
      )
    }

    // Bắt buộc SĐT + chọn quà cho đơn khách mới (WT #106468) — chặn sớm ở nút "Nhận"
    // (ModalPayment.handleOpenModal) lẫn ở đây như lớp an toàn cuối.
    this.assertNewCustomerCakeGiftRequirements()

    if (checkAndGetValidFatherDayGift(this.items, this.onlineOrder, outletCode).isValid) {
      const giftData = checkAndGetValidFatherDayGift(this.items, this.onlineOrder, outletCode)
      if (!some(this.items, item => item.sku === giftData.giftSku)) {
        throw new Error(`Đơn này được tặng ${giftData.giftText} nhưng chưa có`)
      }
    }

    if (checkAndGetValidMotherDay2026Gift(this.items, this.onlineOrder).isValid) {
      const giftData = checkAndGetValidMotherDay2026Gift(this.items, this.onlineOrder)
      if (!some(this.items, item => item.sku === giftData.giftSku)) {
        throw new Error(`Đơn này được tặng ${giftData.giftText} nhưng chưa có`)
      }
    }

    if (checkAndGetValidFatherDay2026Gift(this.items, this.onlineOrder).isValid) {
      const giftData = checkAndGetValidFatherDay2026Gift(this.items, this.onlineOrder)
      if (!some(this.items, item => item.sku === giftData.giftSku)) {
        throw new Error(`Đơn này được tặng ${giftData.giftText} nhưng chưa có`)
      }
    }

    // if (some(this.items, { sku: 'V9117' })) {
    //   throw new Error(
    //     'Sản phẩm Trà đá V9117 chỉ được bán kèm bánh hoặc xôi. Vui lòng chọn trong phần addon'
    //   )
    // }
    if (
      this.voucher &&
      this.voucher.voucherType === 'OPENING_20_PERCENT' &&
      some(this.items, {
        category: 'birthday-cake'
      })
    ) {
      throw new Error('Sản phẩm BSN không dược áp dụng sale khai trương tại cơ sở của bạn')
    }
    const canUseCurrentOutlet = this.rootStore.authenticationStore.canUseCurrentOutlet
    const currentOutlet = this.rootStore!.currentShiftStore.currentOutlet
    if (!this.rootStore.currentShiftStore.loggedInShift && !canUseCurrentOutlet) {
      throw new Error('Chưa thể tạo đơn khi chưa đăng nhập vào ca trực')
    }

    if (!this.rootStore.currentShiftStore.loggedInShift && canUseCurrentOutlet && !currentOutlet) {
      throw new Error('Bạn chưa đăng nhập cũng như chọn cơ sở cho đơn hàng!')
    }
    if (!this.rootStore.currentShiftStore.loggedInShift && !canUseCurrentOutlet) {
      throw new Error('Chưa thể tạo đơn khi chưa đăng nhập vào ca trực')
    }
    if (
      this.orderPlatform === 'SAVOR_SHOP' &&
      some(this.items, item => {
        return ['gojek-combo', 'befood-combo', 'baemin-combo', 'now-combo'].includes(
          get(item, 'subCat', '')
        )
      })
    ) {
      throw new Error('Không được nhập combo đối tác vào đơn shop')
    }
    if (!this.rootStore.currentShiftStore.loggedInShift && canUseCurrentOutlet && !currentOutlet) {
      throw new Error('Bạn chưa đăng nhập cũng như chọn cơ sở cho đơn hàng!')
    }

    if (!this.computedServiceMode) {
      this.setSelectedServiceMode('delivery')
    }

    if (!this.orderCode && this.orderPlatform !== 'SAVOR_SHOP' && this.orderPlatform !== 'NOW') {
      throw new Error('Bạn chưa nhập Code cho đơn hàng')
    }
    if (
      this.orderCode &&
      !['LOSHIP', 'XANH_SM'].includes(this.orderPlatform) &&
      this.orderCode.match(/\D+/)
    ) {
      throw new Error(`Mã đơn chỉ chứa số`)
    }
    if (this.orderPlatform === 'GO_FOOD') {
      if (get(this.orderCode, 'length', 0) < 4) {
        throw new Error(`Mã đơn Go Food phải gồm 4 ký tự`)
      }
      if (get(this.goFoodPin, 'length', 0) < 4) {
        throw new Error(`Mã PIN Go Food phải gồm 4 ký tự`)
      }
    }
    if (this.orderPlatform === 'BE_FOOD') {
      if (get(this.orderCode, 'length', 0) < 3) {
        throw new Error(`Mã đơn Go Food phải gồm 3 ký tự`)
      }
    }
    if (this.orderPlatform === 'XANH_SM') {
      if (!this.headOrderCode || get(this.headOrderCode, 'length', 0) === 0) {
        throw new Error(`Chưa nhập mã đầu đơn hàng XANH_SM`)
      }
      if (get(this.headOrderCode, 'length', 0) !== 4) {
        throw new Error(`Mã đầu đơn hàng XANH_SM phải gồm đúng 4 ký tự`)
      }
      if (!this.tailOrderCode || get(this.tailOrderCode, 'length', 0) === 0) {
        throw new Error(`Chưa nhập mã cuối đơn hàng XANH_SM`)
      }
      if (get(this.tailOrderCode, 'length', 0) !== 4) {
        throw new Error(`Mã cuối đơn hàng XANH_SM phải gồm đúng 4 ký tự`)
      }
      if (get(this.orderCode, 'length', 0) !== 9) {
        throw new Error(
          `Mã đơn XANH_SM phải có định dạng XXXX_XXXX gồm 4 ký tự đầu và 4 ký tự cuối của mã đơn`
        )
      }
    }
    if (this.payments && this.payments.length === 0) {
      throw new Error('Chưa chọn hình thức thanh toán')
    } else {
      if (
        some(this.payments, { paymentType: 'CASH' }) &&
        this.receivedMoney !== 0 &&
        !this.receivedMoney
      ) {
        throw new Error('Chưa nhập số tiền nhận')
      }
    }
    if (this.activePaymentType === 'AIRPAY' && this.orderPlatform !== 'NOW') {
      const values = _.get(_.find(this.payments, { paymentType: 'AIRPAY' }), 'codes')
      if (!_.get(values, 'length')) {
        throw new Error('Chưa nhập mã ShopeePay (AirPay)')
      }
    }

    // Validate voucher: nếu có voucher nhưng discount = 0 thì báo lỗi
    if (this.voucher) {
      const result = this.calculateVoucherResult(this.voucher, this.computedItems, this.subtotal)

      if (result.discount <= 0) {
        // Use the specific error message from calculateVoucherResult if available
        const errorMessage = result.errorMessage
          ? `Voucher "${this.voucher.name}": ${result.errorMessage}`
          : `Voucher "${this.voucher.name}" không áp dụng được cho đơn hàng này. Vui lòng kiểm tra lại điều kiện áp dụng của voucher.`

        throw new Error(errorMessage)
      }
    }

    const { shift, date } = this.rootStore.currentShiftStore.currentShift || {
      shift: '',
      date: ''
    }
    const isAdmin = this.rootStore!.authenticationStore.isAdmin

    if (!isAdmin && !isSameDay(date, new Date())) {
      throw new Error('Ca trực không hợp lệ, Bạn kiểm tra lại nhé !')
    }

    const outlet = canUseCurrentOutlet
      ? getObjectId(
          this.rootStore.currentShiftStore.currentOutlet ||
            this.rootStore.currentShiftStore.currentShift!.outlet
        )
      : getObjectId(this.rootStore.currentShiftStore.currentShift!.outlet)

    if (this.orderPlatform === 'NOW' && !this.nowOrderCode) {
      throw new Error('Chưa chọn mã NOW cho đơn hàng')
    }

    const newOrder: IOrder = {
      _id: this._id,
      orderId: this.orderId,
      status: 'ordered',
      date,
      shift,
      outlet: getObjectId(outlet),
      items: this.items,
      discounts: this.discounts,
      customer: this.computedCustomer,
      voucher: this.voucher,
      orderPlatform: this.orderPlatform,
      selectedOrderPlatform: this.selectedOrderPlatform,
      availableOrderPlatforms: this.availableOrderPlatforms,
      payments: this.payments,
      computedItems: this.computedItems, // Use computedItems directly (tax included if product has tax)
      computedCustomer: this.computedCustomer,
      subTotal: this.subtotal,
      discountTotal: this.discountTotal,
      availableVouchers: this.availableVouchers,
      saleTotal: this.saleTotal,
      deposit: this.deposit,
      created: new Date(),
      ordered: new Date(),
      couponCode: this.couponCode,
      shippingBillNumber: this.shippingBillNumber,
      shippingPaymentMethod: this.shippingPaymentMethod,
      shippingProvider: this.shippingProvider,
      shippingPay: this.shippingPay,
      shippingCollect: this.shippingCollect,
      shippingCustomerName: this.shippingCustomerName,
      shippingCustomerPhone: this.shippingCustomerPhone,
      shippingCustomerAddress: this.shippingCustomerAddress,
      onlineOrderId: this.onlineOrderId,
      serviceMode: this.computedServiceMode,
      cashTotal: this.cashTotal,
      computedReceivableAmount: this.computedReceivableAmount,
      computedReceiveAmount: this.computedReceiveAmount,
      commissionAmount: this.commissionAmount,
      commissionableAmount: this.commissionableAmount,
      commissionPercentage: this.commissionPercentage,
      nowOrderCode: this.nowOrderCode,
      momoTransId: this.momoTransId,
      orderCode: this.orderCode,
      goFoodPin: this.goFoodPin,
      transferCode: this.transferCode,
      groupPaid: this.groupPaid,
      // Tax fields - Phase 2 (currently product tax is included in lineTotal)
      requestInvoice: this.requestInvoice,
      // invoiceSource: this.invoiceSource, // Phase 2
      taxAmount: this.taxAmount, // Still send for backend compatibility
      totalWithTax: this.totalWithTax // Still send for backend compatibility
    }

    if (this.receivedMoney) {
      newOrder.receivedMoney = this.receivedMoney
    }

    // MONKEY PATCHING THE PROBLEM
    const errorItems = newOrder.computedItems.filter(item => {
      if (includes(item.defaultModifierSkus, 'V0353') && !some(item.modifiers, { sku: 'V0353' })) {
        return true
      }
      if (item.sku === 'V0377') {
        return !some(item.modifiers, { sku: 'V0361' })
      }
      if (item.sku === 'V0378') {
        return !some(item.modifiers, { sku: 'V0362' })
      }
      if (item.sku === 'V0379') {
        return !some(item.modifiers, { sku: 'V0350' }) || !some(item.modifiers, { sku: 'V0359' })
      }
      if (item.sku === 'V0380') {
        return (
          !some(item.modifiers, { sku: 'V0356' }) ||
          !some(item.modifiers, { sku: 'V0358' }) ||
          !some(item.modifiers, { sku: 'V0383' })
        )
      }
      if (item.sku === 'V0381') {
        return !some(item.modifiers, { sku: 'V0355' }) || !some(item.modifiers, { sku: 'V0358' })
      }
      if (item.sku === 'V0382') {
        return !some(item.modifiers, { sku: 'V0360' }) || !some(item.modifiers, { sku: 'V0383' })
      }
      if (item.sku === 'V0385') {
        return !some(item.modifiers, { sku: 'V0353' }) && !some(item.modifiers, { sku: 'V0354' })
      }
      return false
    })

    if (errorItems.length) {
      const item = errorItems[0]
      throw new Error(`Sản phẩm ${item.description} chưa có đủ các addon chính trong thành phần`)
    }

    return {
      newOrder,
      outlet,
      shift,
      date
    }
  }

  async sendOrder() {
    try {
      const { newOrder } = this.validateOrder()

      this.setSaving(true)
      await this.rootStore.agent.post<IOrder>('/orders', newOrder)
      this.setOpenModalPayment(false)
    } catch (e) {
      this.setSaving(false)
      this.setOpenModalPayment(true)
      throw e
    } finally {
      this.setSaving(false)
    }

    this.clearOrder()
  }

  async createAndDoneOrder() {
    try {
      const { newOrder, outlet, shift, date } = this.validateOrder()

      this.setSaving(true)

      const response = await this.rootStore.agent.post('/orders/create-and-done', {
        newOrder,
        currentShift: {
          outlet,
          shift,
          date
        }
      })

      const { order, saleEntry } = response

      this.setOrderAndSaleEntryPrinting(order, saleEntry)
    } catch (e) {
      this.setSaving(false)
      throw e
    } finally {
      this.setSaving(false)
    }

    this.clearOrder()

    // Fetch pre-order mooncake quantities after successful order completion for B4
    // const outletCode = this.getOutletCode()
    // if (outletCode === 'B4') {
    //   this.fetchPreOrderMooncakeQuantities()
    // }
  }

  setOrderAndSaleEntryPrinting(order: any, saleEntry: any) {
    this.orderPrinting = order
    this.saleEntryPrinting = saleEntry
  }

  setShippingData(data: {
    shippingProvider: TShippingProvider | null
    shippingPay: number
    shippingCollect: number
    shippingBillNumber: string
    shippingPaymentMethod: string
    shippingCustomerName: string
    shippingCustomerPhone: string
    shippingCustomerAddress: string
    onlineOrderId: string
  }) {
    this.shippingBillNumber = data.shippingBillNumber
    this.shippingPaymentMethod = data.shippingPaymentMethod
    this.shippingProvider = data.shippingProvider
    this.shippingPay = data.shippingPay
    this.shippingCollect = data.shippingCollect
    this.shippingCustomerName = data.shippingCustomerName
    this.shippingCustomerPhone = data.shippingCustomerPhone
    this.shippingCustomerAddress = data.shippingCustomerAddress
    this.onlineOrderId = data.onlineOrderId
  }

  get orderPlatform(): TOrderPlatform {
    if (this.availableOrderPlatforms.includes(this.selectedOrderPlatform)) {
      return this.selectedOrderPlatform
    }
    return head(this.availableOrderPlatforms) || 'SAVOR_SHOP'
  }

  get availableOrderPlatforms(): TOrderPlatform[] {
    const basePlatforms: TOrderPlatform[] = [
      'SAVOR_SHOP',
      'NOW',
      'LOSHIP',
      'GRAB_FOOD',
      'BAEMIN',
      'BE_FOOD',
      'VINID',
      'XANH_SM'
    ]

    if (this.autosave) {
      return basePlatforms
    }

    if (this.rootStore.currentShiftStore.loggedInShift) {
      return basePlatforms
    }

    return ['SAVOR_SHOP']
  }

  setOrderPlatform(orderPlatform: TOrderPlatform) {
    this.selectedOrderPlatform = orderPlatform
  }

  orderPlatformReaction = reaction(
    () => {
      return {
        loggedInShift: this.rootStore.currentShiftStore.loggedInShift,
        canUseCurrentOutlet: this.rootStore.authenticationStore.canUseCurrentOutlet
      }
    },
    ({ loggedInShift, canUseCurrentOutlet }) => {
      this.setOrderPlatform('SAVOR_SHOP')
    }
  )

  loadOrderStore(order: IOrder) {
    this.orderId = order.orderId
    this.outlet = order.outlet
    this.items = order.items
    this._id = order._id
    this.customer = order.customer
    this.computedCustomer = order.computedCustomer
    this.voucher = order.voucher
    this.selectedOrderPlatform = order.orderPlatform
    this.payments = order.payments
    this.shippingProvider = order.shippingProvider
    this.shippingPay = order.shippingPay
    this.shippingCollect = order.shippingCollect
    this.couponCode = order.couponCode
    this.shippingBillNumber = order.shippingBillNumber
    this.shippingPaymentMethod = order.shippingPaymentMethod
    this.shippingCustomerName = order.shippingCustomerName
    this.shippingCustomerPhone = order.shippingCustomerPhone
    this.shippingCustomerAddress = order.shippingCustomerAddress
    this.onlineOrderId = order.onlineOrderId
    this.status = order.status
    this.ordered = order.ordered
    this.updated = order.updated
    this.selectedServiceMode = order.serviceMode
  }

  setAutoSave(value: boolean) {
    this.autosave = value
  }

  setAutoUpdateProductStatus(value: boolean) {
    this.autoUpdateProductStatus = value
  }

  setSelectedServiceMode(value: string) {
    this.selectedServiceMode = value
  }

  addPayment(payment: IPayment) {
    if (payment.paymentType === 'MOMO') {
      payment.commissionAmount = payment.amount * 0.01
    }
    if (this.payments) {
      this.payments = [payment]
    }
  }

  chooosePaymentType(type: TPaymentType) {
    // info: payments
    let amount = this.saleTotal + this.shippingCollect - this.commissionAmount - this.deposit
    if (this.shippingPaymentMethod === 'customerSubtract') {
      amount -= this.shippingPay
    }
    this.addPayment({
      paymentType: type,
      amount,
      code: '',
      uniqueId: Math.random().toString(36).substring(4),
      commissionAmount: 0,
      codes: []
    })
  }

  get activePaymentType() {
    if (this.payments && this.payments.length) {
      return this.payments[0].paymentType
    }
    return null
  }

  resetPayments() {
    this.payments = []
  }

  removePayment(uniqueId: string) {
    if (this.payments) {
      this.payments = this.payments.filter(payment => payment.uniqueId !== uniqueId)
    }
  }

  setOpenModalPayment(state: boolean) {
    this.openModalPayment = state
  }

  setReceivedMoney(money: number) {
    this.receivedMoney = money
  }
  setOrderCode(code: String) {
    this.orderCode = code
  }
  setGoFoodPin(code: String) {
    this.goFoodPin = code
  }
  setHeadOrderCode(code: String) {
    this.headOrderCode = code
    if (this.orderPlatform === 'XANH_SM' && this.headOrderCode && this.tailOrderCode) {
      this.orderCode = `${this.headOrderCode}_${this.tailOrderCode}`
    }
  }
  setTailOrderCode(code: String) {
    this.tailOrderCode = code
    if (this.orderPlatform === 'XANH_SM' && this.headOrderCode && this.tailOrderCode) {
      this.orderCode = `${this.headOrderCode}_${this.tailOrderCode}`
    }
  }
  setTransferCode(transferCode: String) {
    this.transferCode = transferCode
  }
  toggleGroupPaid() {
    this.groupPaid = !this.groupPaid
  }
  setCodes(codes: string[]) {
    this.payments = map(this.payments, it => {
      it.codes = codes
      return it
    })
  }
  async fetchActiveNowOrders() {
    try {
      const currentShift = this.rootStore!.currentShiftStore.currentShift

      if (!currentShift) return toast.error('Chưa đăng nhập ca trực')

      const nowOrders = await this.rootStore.agent.get('/now-orders', {
        params: {
          currentShiftId: currentShift._id,
          statuses: [1, 4, 2]
        }
      })

      this.setActiveNowOrders(nowOrders)
    } catch (e) {
      handleAgentErrorResponse(e)
    }
  }
  async fetchOnlineOrder(onlineOrderId: string) {
    try {
      const onlineOrder = await this.rootStore.agent.get('/online-orders/search', {
        params: {
          onlineOrderId,
          triggerSource: 'savor_pos'
        }
      })
      if (!onlineOrder) return toast.error('Không tìm thấy online order tương ứng')
      this.setOnlineOrder(onlineOrder)
    } catch (e) {
      handleAgentErrorResponse(e)
    }
  }
  validateSaleCodeForSale({ saleCode }: { saleCode: any }) {
    if (saleCode.typeGroup !== 'bsn') {
      return 'Không phải Sale Code BSN'
    }
    if (saleCode.status === 'disabled') {
      return 'Sale Code đã bị khóa'
    }
    if (saleCode.status === 'pending') {
      return 'Sale Code đang chờ duyệt'
    }
    if (saleCode.expiryDate) {
      const now = new Date()
      if (isAfter(now, new Date(saleCode.expiryDate))) {
        return 'Sale code đã hết hạn'
      }
    }
    const outlet = this.rootStore.authenticationStore.canUseCurrentOutlet
      ? this.rootStore.currentShiftStore.currentOutlet ||
        this.rootStore.currentShiftStore.currentShift!.outlet
      : this.rootStore.currentShiftStore.currentShift!.outlet
    const outletCode = _.get(outlet, 'code')
    if (outletCode && !_.includes(_.map(saleCode.outlets, 'code'), outletCode)) {
      return `Sale code không áp dụng cho cơ sở ${outletCode} hiện tại`
    }
    if (saleCode.quantity <= 0) {
      return 'Sale code đã dùng hết số lượng'
    }
    return ''
  }

  async fetchSaleCode(saleCodeId: string) {
    try {
      const saleCodeData = await this.rootStore.agent.get(`/sale-codes/search`, {
        params: { saleCodeId }
      })
      const saleCode = saleCodeData.saleCode
      if (!saleCode) {
        return toast.error(`Không tìm thấy sale code ${saleCodeId}`)
      }
      this.handleAddSaleCodeToItems(saleCode)
    } catch (e) {
      handleAgentErrorResponse(e)
    }
  }
  handleAddSaleCodeToItems(saleCode: any) {
    // validate sale code
    const error = this.validateSaleCodeForSale({ saleCode })
    if (error) {
      return toast.error(error)
    }
    // validate product
    const saleCodeMatchedProduct = this.findProducts(saleCode.sku)
    if (!saleCodeMatchedProduct) {
      return toast.error(`Không tìm thấy sản phẩm cho sku ${saleCode.sku}`)
    }
    const rootSaleCodeItem: IOrderItem = {
      ...saleCodeMatchedProduct,
      id: `${Date.now()}`,
      modifiers: [],
      noLoyalty: true,
      quantity: saleCode.quantity
    }
    const rootSoldPrice = getItemSoldPrice({
      item: rootSaleCodeItem,
      orderPlatform: this.orderPlatform,
      orderType: this.orderType
    })
    if (saleCode.salePrice > rootSoldPrice) {
      return toast.error(
        `Giá sale code ${saleCode.saleCodeId} (${saleCode.salePrice}) lớn hơn giá bán ${rootSoldPrice}. Vui lòng liên hệ CSKH/MKT để kiểm tra lại`
      )
    }
    const saleCodeItem: IOrderItem = {
      ...rootSaleCodeItem,
      salePrice: saleCode.salePrice,
      saleCode: saleCode._id,
      saleCodeId: saleCode.saleCodeId,
      manufacturingDate: saleCode.manufacturingDate
    }
    this.addItem(saleCodeItem)
    toast.success('Đã thêm sản phẩm từ Sale code')
  }

  async fetchLinkQrTransfer({
    transferContent,
    totalMoney,
    testAutoConfirm
  }: {
    transferContent: string
    totalMoney: number
    testAutoConfirm: boolean
  }) {
    this.setTransferContent(transferContent)
    try {
      // Get outlet ID from current shift
      const outletId = this.rootStore.currentShiftStore.currentShift
        ? getObjectId(this.rootStore.currentShiftStore.currentShift.outlet)
        : this.rootStore.currentShiftStore.currentOutlet
          ? getObjectId(this.rootStore.currentShiftStore.currentOutlet)
          : null

      const dataObj = await this.rootStore.agent.post('/api/payment-transfer/get-payment-link', {
        transferContent,
        totalMoney,
        testAutoConfirm,
        outletId,
        itemSkus: map(this.items, 'sku')
      })
      console.log('dataObj', dataObj)
      if (!get(dataObj, 'link')) {
        this.setLinkQrTransferError(`Có lỗi khi lấy link QR từ server. ${dataObj.message}`)
      } else {
        this.setLinkQrTransfer(dataObj.link)
      }
    } catch (e) {
      console.log('🚀 ~ OrderStore ~ fetchLinkQrTransfer ~ e:', e)
      if (e instanceof Error) {
        const errMessage: string = getMessageFromErrorResponse(e)
        this.setLinkQrTransferError(`Có lỗi chưa lấy được link QR từ server. ${errMessage}`)
        handleAgentErrorResponse(e)
      }
    }
  }

  findProducts(sku: String) {
    return find(this.rootStore!.productStore.products, (product: IProduct) =>
      isEqual(product.sku, sku)
    )
  }

  setOnlineOrder(onlineOrder: any) {
    forEach(onlineOrder.items, item => {
      const matchProduct = this.findProducts(item.sku)
      if (!matchProduct) {
        return
      }
      if (matchProduct.sku === 'V1408') {
        const bundledProducts = reduce(
          item.bundledProducts,
          (result: any, bundled: any) => {
            let array = [1]
            if (bundled.quantity === 2) {
              array = [1, 1]
            }
            forEach(array, quantity => {
              result.push({ sku: bundled.sku, description: bundled.description, quantity })
            })
            return result
          },
          []
        )

        const comboElements = map(matchProduct.comboElements, (combo, index) => {
          let sku = bundledProducts[index].sku
          return {
            name: combo.name,
            selectedItem: {
              sku: bundledProducts[index].sku,
              price: get(find(combo.itemOptions, { sku }), 'price', 0)
            },
            itemOptions: combo.itemOptions,
            maxQuantity: combo.maxQuantity
          }
        })

        const normalPrice = reduce(
          comboElements,
          (result, comboElement) => {
            result +=
              get(comboElement, 'selectedItem.price', 0) * get(comboElement, 'maxQuantity', 1)
            return result
          },
          0
        )
        this.addProductToItems({
          _id: getObjectId('62579fa53fc8f53105a806f8'),
          sku: matchProduct.sku,
          comboElements,
          description: 'Combo 2 bánh sinh nhật',
          normalPrice,
          category: 'combo',
          isCombo: true
        })

        const comboProduct = findLast(this.items, (item: IOrderItem) =>
          isEqual(item.sku, matchProduct.sku)
        )
        comboElements.forEach(comboElement => {
          const matchProduct = cloneDeep(this.findProducts(comboElement.selectedItem!.sku))

          if (matchProduct) {
            matchProduct.comboId = comboProduct!.id
            matchProduct.comboName = comboProduct!.description
            matchProduct.quantity = get(comboElement, 'maxQuantity', 1)
            this.addProductToItems(matchProduct)
          }
        })
        return
      }
      const productItem: IOrderItem = {
        ...matchProduct,
        id: `${Date.now()}`,
        quantity: item.quantity,
        hasSaltedEgg: item.hasSaltedEgg,
        modifiers: [],
        noLoyalty: false,
        normalPrice: item.originalPrice,
        salePrice: item.soldPrice,
        bundledProducts: item.bundledProducts,
        saleCode: _.get(item, 'saleCode._id', null),
        saleCodeId: _.get(item, 'saleCode.saleCodeId', null),
        cakeVariants: item.variants,
        onlineOrderUid: item.onlineOrderUid,
        // liên quan convert sale entry
        onlineOrderId: onlineOrder.onlineOrderId,
        cakeOrderSource: 'app.savor.vn'
      }
      if (item.discount > 0 && item.saleProgram !== 'Giảm giá nhân viên') {
        productItem.onlineOrderDiscount = {
          discount: item.discount,
          saleProgram: item.saleProgram
        }
      }
      this.addItem(productItem)
    })
    this.onlineOrder = onlineOrder
    if (onlineOrder.voucher) {
      this.voucher = onlineOrder.voucher
    }

    this.deposit = sumBy(onlineOrder.deposits, 'amount')
  }
  setActiveNowOrders(orders: any) {
    this.activeNowOrders = orders
  }

  setNowOrderCode(code: string) {
    this.nowOrderCode = code
  }

  setTransferContent(content: string) {
    this.transferContent = content
  }

  setLinkQrTransferError(error: string) {
    this.linkQrTransferError = error
  }
  setLinkQrTransfer(link: string) {
    this.linkQrTransfer = link
  }
  setLinkQrCode(link: string) {
    this.linkQrcode = link
  }

  setMomoTransId(code: string) {
    this.momoTransId = code
  }
}

decorate(OrderStore, {
  _id: observable,
  nowOrderCode: observable,
  activeNowOrders: observable,
  onlineOrder: observable,
  orderId: observable,
  momoTransId: observable,
  orderPrinting: observable,
  saleEntryPrinting: observable,
  outlet: observable,
  items: observable,
  autosave: observable,
  autoUpdateProductStatus: observable,
  customer: observable,
  computedCustomer: observable,
  voucher: observable,
  userExplicitlySelectedNoVoucher: observable,
  isNewCustomerGiftDeclined: observable,
  setNewCustomerGiftDeclined: action,
  isCustomerNoPhoneConfirmed: observable,
  setCustomerNoPhoneConfirmed: action,
  isNewCustomerCakeGiftPhoneRequired: computed,
  requestInvoice: observable,
  // invoiceSource: observable, // Phase 2
  orderPlatform: computed,
  availableOrderPlatforms: computed,
  selectedOrderPlatform: observable,
  payments: observable,
  activePaymentType: computed,
  couponCode: observable,
  covidCoupon: observable,
  voucherCode: observable,
  setCouponCode: action,
  setCovidCoupon: action,
  setVoucherCode: action,
  shippingProvider: observable,
  shippingPay: observable,
  shippingCollect: observable,
  shippingBillNumber: observable,
  shippingPaymentMethod: observable,
  shippingCustomerName: observable,
  shippingCustomerPhone: observable,
  shippingCustomerAddress: observable,
  onlineOrderId: observable,
  selectedServiceMode: observable,
  note: observable,
  status: observable,
  ordered: observable,
  updated: observable,
  openModalPayment: observable,
  saving: observable,
  receivedMoney: observable,
  orderCode: observable,
  headOrderCode: observable,
  tailOrderCode: observable,
  transferContent: observable,
  linkQrTransferError: observable,
  linkQrTransfer: observable,
  linkQrcode: observable,
  preOrderMooncakeQuantities: observable,
  discounts: computed,
  computedItems: computed,
  taxAmount: computed,
  totalWithTax: computed,
  // hasAlcoholItems: computed, // Phase 2
  // canUseHouseholdInvoice: computed, // Phase 2
  discountItemMap: computed,
  subtotal: computed,
  discountTotal: computed,
  saleTotal: computed,
  availableVouchers: computed,
  cashTotal: computed,
  toCollectAmount: computed,
  computedServiceMode: computed,
  computedReceivableAmount: computed,
  computedReceiveAmount: computed,
  commissionAmount: computed,
  commissionableAmount: computed,
  commissionPercentage: computed,
  isPendingCustomerCard: computed,
  customerCardStage: computed,
  setActiveNowOrders: action,
  setOnlineOrder: action,
  setNowOrderCode: action,
  addItem: action,
  setReceivedMoney: action,
  selectVariant: action,
  setNormalPrice: action,
  selectProduct: action,
  selectItemOptionForCombo: action,
  removeItem: action,
  changeItemQuantity: action,
  changeItemManufacturingDate: action,
  changeItemNote: action,
  addModifier: action,
  subtractModifier: action,
  removeModifier: action,
  clearOrder: action,
  fetchPreOrderMooncakeQuantities: action,
  setCustomer: action,
  clearCustomer: action,
  setVoucher: action,
  // setRequestInvoice: action, // Phase 2
  // setInvoiceSource: action, // Phase 2
  _setComputedCustomer: action,
  setShippingData: action,
  setOrderPlatform: action,
  loadOrderStore: action,
  setAutoSave: action,
  setAutoUpdateProductStatus: action,
  setSelectedServiceMode: action,
  addPayment: action,
  setCodes: action,
  chooosePaymentType: action,
  resetPayments: action,
  sendOrder: action,
  createAndDoneOrder: action,
  setOrderAndSaleEntryPrinting: action,
  setOpenModalPayment: action,
  removePayment: action,
  setSaving: action,
  setTransferContent: action,
  setLinkQrTransferError: action,
  setLinkQrTransfer: action,
  setLinkQrCode: action,
  setMomoTransId: action,
  setOrderCode: action,
  setGoFoodPin: action,
  setHeadOrderCode: action,
  setTailOrderCode: action
})
